import { commaedInteger, formatDigits } from '../scripts/weapp-commons/util/string-util';
/**
 * @generated
 */

export const textZhTw = {
  c: `預約手續費的100%`,
  liquidProductsNotice: (className: string) =>
    `請留意！ ※如訂單<span class=${className}>含有液體</span>。搭乘飛機時<span class=${className}>建議放入托運行李中</span>。`,
  airports: {
    airportSwitched: `已變更取貨地點。`,
    areYouSureToSwitchAirport: `真的要更改取貨櫃台嗎？`,
    map: `地圖`,
    mapTitle: (shop: string) => `${shop}的取貨地點說明`,
    metaDescription: (shop: string) =>
      `透過完美行購物購買日本伴手禮，來日本旅行時便能在${shop}领取購買的商品。讓來日本旅行時能以更輕鬆！`,
    pickupAirport: `取貨地點`,
    selectPickupAirport: `選擇取貨地點`,
    switchingAirportWouldClearCart: `更改取貨櫃台會清空當前購物車`
  },
  allVisitorCampaign: {
    allYouCanUse: (highlight: string, currency: string) =>
      `所有人都能使用的<span class=${highlight}>1,000<span class=${currency}>日圓</span>折扣</span>`,
    click: `點擊`,
    getCoupon: `領取優惠券`,
    getSoon: `立即領取`
  },
  amounts: {
    checkVendorAmount: `請確認各供應商的總金額`,
    consumptionTax: `消費稅`,
    discounted: `折扣`,
    drugPurchasableAnnotation: `杉药房购物车中的总金额超过 1,000 日元时可用。`,
    explanationOfLocalCurrencyAmount: (date: string) =>
      `※日圓以外的價格為根據 ${date} 匯率計算出的參考價格。\n各信用卡公司匯率可能不同 詳情向信用卡公司確認。`,
    maximumTotalAmountIs500000JPY: `最高金額為500,000日圓`,
    minimalTotalAmountIs1000Jpy: `1000日圓以上即可購買`,
    minimalTotalAmountIs3000Jpy: `3000日圓以上即可購買`,
    minimalTotalAmountIs5000Jpy: `金額需滿5,000日圓`,
    orderAmount: `訂單金額`,
    purchaseAmount: `支付金額`,
    shopDiscountAmount: `入站票折扣`,
    subtotalAmount: `小計`,
    taxFree: `免稅`,
    taxFreeIfTotalAmountExceeds5kJpy: `商品總金額超過5,000日圓即可免消費稅`,
    totalAmount: `總金額`
  },
  announce: {
    noteText: `※因應物流業者的新年假期，目前暫停受理12/30～1/7期間取貨的訂單。1/8以後取貨的訂單則可照常訂購。`
  },
  auth: {
    accountNotYet: `還沒有會員帳號？`,
    creditCardList: `信用卡管理`,
    lookForwardToServingYouAgain: `歡迎再次使用！`,
    signIn: `登入`,
    signUp: `註冊`,
    signUpNow: `立即註冊`,
    signedOut: `已登出`,
    signUpCoupon: {
      alt: `500日圓折扣`,
      getNow: `立即領取`,
      title: `新加入會員`
    }
  },
  banner: {
    cosmetics: {
      featured: `特集`,
      mustBuy: `必買\n日本人氣美妝`,
      postCovid: `後疫情時代必需品`
    },
    skincare: {
      recommended: `編輯部推薦\n人氣單品`,
      specialSet: `夏季護膚\n特集`
    },
    snacks: {
      haveATry: `嚐嚐看`,
      souvenirs: `伴手禮`
    },
    walkthrough: {
      amazingTaxFreeService: `全新免稅服務`,
      onlyIn3min: `最短3分鐘`,
      seeMoreAmazingSights: `享受觀光樂趣`,
      title: `旅行前預約，\n並於機場取貨`
    }
  },
  brands: {
    cosmeticBrand: `化妝品品牌`,
    cosmeticBrandTitle: (cosmeticBrand: string) => `${cosmeticBrand}免稅商品`,
    description: `品牌一覽。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
    searchResult: `搜尋結果`,
    titleName: `品牌`,
    viewAll: `查看所有品牌`,
    index: {
      strokeCount: `畫`
    },
    list: {
      title: `品牌一覽`
    },
    meta: {
      description: (brand: string) =>
        `${brand}的日本免稅商品。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
      descriptionWithParams: (brand: string, category: string) =>
        `${brand} ${category}的日本免稅商品。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
      title: (brand: string) => `${brand}的日本免稅商品`,
      titleWithParams: (brand: string, category: string) => `${brand} ${category}的日本免稅商品`
    },
    search: {
      placeholder: `請輸入品牌名稱`
    },
    slug: {
      description: (brand: string) =>
        `${brand}的日本免稅商品。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`
    }
  },
  campaign: {
    present: `贈品`,
    bank: {
      esun: `刷玉山銀行信用卡即可獲得最大25%折扣優惠券`,
      taiwanMobile: `台灣大哥大用戶限定優惠！最大2500日圓OFF！`,
      title: `眾多超值活動舉辦中！由此查看活動內容！`,
      ubot: (price: string, discount: string) => `使用聯邦銀行信用卡結帳滿${price}日圓即可享有${discount}折扣優惠`,
      yuanta: `刷元大銀行信用卡即可獲得最大20%折扣優惠券`
    },
    fancl: {
      addNowToCart: `立即加入購物車`,
      goodDealPrice: (price1: string, price2: string) => `原價 ${price1}日圓(含稅)，現省${price2}日圓`,
      limitedSpecialSet: `FANCL限量特別套組！`,
      specialSetPrice: `特別套組價格`,
      usageStep: `使用步驟`,
      brighteningSet: {
        present: `＜贈品＞MCO速淨卸粧油 120ml`,
        product1: `・MCO速淨卸粧油 BLACK＆SMOOTH 120ml`,
        product2: `・毛孔淨化潔膚泥膠`,
        product3: `・亮白化妝水 滋潤型〈藥用化妝品〉 30ml`,
        product4: `・美白透亮精華露〈藥用化妝品〉 18ml`,
        product5: `・亮白乳液 滋潤型〈藥用化妝品〉 30ml`,
        product6: `・活膚祛黑精華面膜 6片`,
        product7: `・長效清透防曬露50+ (SPF50 PA++++) 60ml`,
        title: `美白套組`,
        whatMelanin: `※1 美白意指防止黑色素生成，預防色斑和雀斑。\n（MCO速淨卸粧油、毛孔淨化潔膚泥膠、長效清透防曬露50+ (SPF50 PA++++) 除外）`
      },
      og: {
        description: `完美行首次推出FANCL限量特別套組！ 以更超值的價格輕鬆購買免税商品，就到完美行購物！`,
        title: `完美行首次推出FANCL限量特別套組！ | 完美行購物`
      },
      pores: {
        present: {
          description: `宛如精華液般「親膚柔滑」的油性質地，無須摩擦即可卸除。打造看不見毛孔的水嫩柔滑肌。`,
          name: `卸粧`,
          title: `MCO速淨卸粧油 60ml`
        },
        step1: {
          description: `徹底清潔毛孔髒污的酵素洗顏粉。`,
          name: `洗顔`,
          title: `黑炭酵素深層清潔洗顏粉 30個`
        },
        step2: {
          description: `無需撕除，以水洗淨即可。短短5分鐘，帶走毛孔黑頭污垢讓肌膚潔淨清透！`,
          name: `潔淨`,
          title: `黑頭潔淨軟膜　40g`
        },
        step3: {
          description: `局部用的毛孔細緻精華露，針對令人在意的毛孔問題，抑制油脂防止泛油光，讓肌膚細緻又乾爽。`,
          name: `毛孔精華露`,
          title: `毛孔細緻精華露 8g`
        },
        step4: {
          description: `局部用的毛孔細緻精華露，針對令人在意的毛孔問題，抑制油脂防止泛油光，讓肌膚細緻又乾爽。`,
          name: `潔膚`,
          title: `毛孔淨化潔膚泥膠　120g`
        },
        step5: {
          description: `宛如精華液般「親膚柔滑」的油性質地，無須摩擦即可卸除。打造看不見毛孔的水嫩柔滑肌。`,
          name: `卸粧`,
          title: `MCO速淨卸粧油 120ml`
        },
        step6: {
          description: `適用於有毛孔護理需求的朋友，推薦給「在意鼻翼汙垢」、「希望膚質更加柔滑細緻」的您！`,
          name: `卸粧`,
          title: `MCO速淨卸粧油 BLACK＆SMOOTH 120ml`
        }
      },
      poresSet: {
        present: `＜贈品＞MCO速淨卸粧油 60ml`,
        product1: `・黑炭酵素深層清潔洗顏粉 30個`,
        product2: `・黑頭潔淨軟膜　40g`,
        product3: `・毛孔細緻精華露 8g`,
        product4: `・毛孔淨化潔膚泥膠　120g`,
        product5: `・MCO速淨卸粧油 120ml`,
        product6: `・MCO速淨卸粧油 BLACK＆SMOOTH 120ml`,
        title: `毛孔護理套組`
      },
      present: {
        description: `宛如精華液般「親膚柔滑」的油性質地，無須摩擦即可卸除。打造看不見毛孔的水嫩柔滑肌。`,
        name: `卸粧`,
        title: `MCO速淨卸粧油 120ml`
      },
      step1: {
        description: `適用於有毛孔護理需求的朋友，推薦給「在意鼻翼汙垢」、「希望膚質更加柔滑細緻」的您！`,
        name: `卸粧`,
        title: `MCO速淨卸粧油 BLACK＆SMOOTH 120ml`
      },
      step2: {
        description: `每天持續使用，可為毛孔深層淨污，再現光滑細緻膚質。`,
        name: `潔膚`,
        title: `毛孔淨化潔膚泥膠　120g`
      },
      step3: {
        description: `滋潤型藥用美白化妝水，為您打造健康勻淨的透亮美肌。`,
        name: `化妝水`,
        title: `亮白化妝水 滋潤型〈藥用化妝品〉 30ml`
      },
      step4: {
        description: `直達黑斑根源進行修護，實現透亮美肌。`,
        name: `精華露`,
        title: `美白透亮精華露〈藥用化妝品〉 18ml`
      },
      step5: {
        description: `滋潤型藥用美白乳液，為您打造水潤持久的透亮美肌。`,
        name: `乳液`,
        title: `亮白乳液 滋潤型〈藥用化妝品〉 30ml`
      },
      step6: {
        description: `一片面膜蘊含1瓶以上的美白精華液。`,
        name: `面膜`,
        title: `活膚祛黑精華面膜 6片`
      },
      step7: {
        description: `高效耐水抗汗，並阻隔強烈紫外線與外來刺激！`,
        name: `防曬`,
        title: `長效清透防曬露50+ (SPF50 PA++++) 60ml`
      }
    },
    jcb: {
      aboutFlow1: `<em>最短在希望取貨日的3天前</em><br>上網或使用APP完成預約購買`,
      aboutFlow2: `<em>所需時間約3分鐘！</em><br>前往置物櫃，<br>進行人臉辨識及護照確認，<br>即可完成免稅手續並結帳`,
      aboutFlow3: `領取放在<em>置物櫃</em>裡<br>的購入商品`,
      aboutNote: `（取貨地點可選擇日本全國指定的機場或是車站）`,
      aboutText: `利用於全國指定車站或機場內設置的<em>置物櫃型自動販賣機</em>，<br>即可領取已預約商品的線上免稅購物服務。`,
      flow1: `將合計<em>1萬日圓<sup>※</sup> 以上</em>的商品加入購物車後、點選<em>購物車圖示按鈕</em>，進到結帳畫面`,
      flow2: `按下詳細金額旁邊的「<em>選擇優惠券</em>」（英語則是「<em>Select Coupon</em>」），選擇並輸入上面的優惠券代碼`,
      flow3: `於下一個結帳畫面選擇「<em>JCB</em>」，完成預約購買`,
      meta: `JCB會員限定企劃！只要購物1萬日圓以上，就能折抵免稅商品2,000日圓`,
      noteForCondition: `※此為折扣前的金額　\n※部分商品不適用此折扣活動`,
      noteForFlow: `※1萬日圓以上的訂單內容皆須為適用折扣的商品`,
      period: `2023年10月16日（一）  〜 2024年1月15日（一） （台灣時間22:59為止）`,
      shoppingTitle: `即將接近一年的尾聲，看看有哪些適合拿來送禮的美食伴手禮`,
      banner: {
        notice: `※不適用JCB優惠券`,
        title: `WAmazing 其他服務`
      },
      notes: {
        note1: `・除日本及香港發行的卡，其餘國家及地區的JCB信用卡皆為適用對象。`,
        note10: `・參加本活動的貴賓，即代表同意將個人資訊提供給完美行以及JCB International Inc.。`,
        note2: `・需使用JCB信用卡結帳。`,
        note3: `・優惠券1人僅限使用1次。`,
        note4: `・優惠券無法併用。`,
        note5: `・優惠券的使用期限至日本時間2024年1月15日23:59。`,
        note6: `・無法將本活動的權利轉讓給他人，亦無法轉換成現金。`,
        note7: `・本活動可能會在未事先通知的情況下變更活動內容或終止活動，敬請見諒。`,
        note8: `・部分商品不適用本活動。`,
        note9: `・將於資訊公開時，一併記載確切的活動舉辦期間。\n本活動有可能於上述時間結束後仍持續進行。`
      },
      shopping: {
        brandTitle153: `〈正品〉資生堂`,
        brandTitle426: `〈正品〉SK-II`,
        brandTitle7558: `柿之種米果`,
        brandTitle8472: `瀨戶內檸檬農園`,
        brandTitle9422: `沖繩南風堂`,
        brandTitle9516: `巖手屋`,
        brandTitle9538: `〈正品〉FANCL`,
        brandTitle9597: `〈正品〉黛珂`,
        catch153: `高人氣抗老護理保養品`,
        catch426: `SK-II熱銷品`,
        catch6842: `北海道品牌`,
        catch6937: `送禮人氣No.1`,
        catch7534: `門市熱銷不斷`,
        catch7558: `東京限定`,
        catch7696: `內含皇冠哈密瓜果肉`,
        catch8472: `來自檸檬產量日本第一的廣島`,
        catch9422: `來自沖繩縣、回購不斷的勁辣好滋味`,
        catch9516: `岩手知名甜點`,
        catch9538: `完美行限定的正品`,
        catch9597: `獲獎無數的熱銷美妝No.1`,
        description153: `打造水潤彈力肌膚的美容晚霜。好推不黏膩，能確實服貼肌膚。`,
        description426: `SK-II 最暢銷的美白精華液。防止肌膚因為紫外線而產生斑點及暗沉，打造由內到外的透亮肌膚。`,
        description6842: `加入大量北海道牛奶的「牛奶口味」、以及搭配知名的高級抹茶產地——西尾產抹茶的「抹茶牛奶口味」，總計共6種口味！`,
        description6937: `小包裝設計，一次享用五種口味，最適合拿來當伴手禮！`,
        description7534: `由熟悉起司的專業職人們監製，打造出味道、香氣、口感皆十分講究的起司點心。`,
        description7558: `甜辣天丼風味、文字燒風味、濃厚法式多蜜醬風味、高湯咖哩風味，每種風味各有4包`,
        description7696: `加入最高級的哈密瓜——皇冠哈密瓜果肉的果凍與布丁組合`,
        description8472: `外頭酥脆、中間鬆軟。有著清爽檸檬風味且不會過甜，嚐過就停不下來的美味，非常推薦於下午茶時享用。`,
        description9422: `辛辣口感讓人無法抗拒。加入沖繩島唐辛子的酥脆蝦餅`,
        description9516: `以小麥及芝麻為材料，再加上少許的鹽，製作出擁有樸素的基本口味，並搭配各種材料變化出不同風味的南部煎餅。`,
        description9538: `推薦給零毛孔肌膚的卸妝油及精華液5款商品組合。現在購買還多贈送1罐卸妝油。`,
        description9597: `多次榮獲最佳美妝大賞No.1！即使睡眠不足，肌膚看起來仍像是多睡3小時般亮麗的修復霜。`,
        moreButton1: `編輯部推薦伴手禮`,
        moreButton2: `查看更多日本全國伴手禮`,
        moreButton3: `查看更多推薦商品`,
        notice: `※目前以2023年8月底的匯率做計算。實際購買金額以購買當下的最新匯率為準。`,
        sectionTitle1: `即將接近一年的尾聲，看看有哪些適合拿來送禮的美食伴手禮`,
        sectionTitle2: `日本人超推！只有當地才買得到的伴手禮`,
        sectionTitle3: `現在買最划算的必買商品`,
        text153: `怡麗絲爾 膠原緊膚晚霜 W`,
        text426: `超肌因鑽光淨白精華 30ml`,
        text6842: `LANGUE DE CHAT 30片混裝`,
        text6937: `薯條餅乾迷你禮盒 10入`,
        text7534: `起司奶油脆餅 12塊裝`,
        text7558: `東京限定　龜田土產柿之種`,
        text7696: `靜岡皇冠哈密瓜果凍 8個入（含3支特製金湯匙）`,
        text8472: `銀鈴檸檬蛋糕`,
        text9422: `島唐辛子辣味蝦餅（小）`,
        text9516: `Nico Nico 南部煎餅`,
        text9538: `【毛孔淨化套組】`,
        text9597: `Liposome Advanced Repair Cream 50g`
      }
    }
  },
  cart: {
    addToCart: `放入購物車`,
    addedToCart: `已放入購物車`,
    cartCollections: `購物車一覽`,
    cartIsEmpty: `購物車中還沒有商品`,
    cartIsEmptyToTop: `回到首頁`,
    cartIsEmptyToTopAndAddProducts: `回到首頁\n加入喜愛的商品吧!`,
    continueShopping: `繼續購物`,
    detail: `詳細金額`,
    insufficientAmountToPurchase: (insufficientAmount: number) => `須再加入${insufficientAmount}日圓的商品即可訂購`,
    proceedToForm: `建立訂單`,
    purchasable: `可訂購`,
    showToCart: `查看購物車`,
    taxFreeShopOrderingCondition: (shopName: string) => `${shopName}的每次的購買金額下限為5000日圓(折扣後)`,
    taxableShopOrderingCondition: (shopName: string) => `${shopName}的每次的購買金額下限為1000日圓`,
    title: `購物車`,
    agree: {
      addToCart: `同意並加入購物車`
    },
    cannotPickup: {
      removeItem: `不能領取,请移除。`
    },
    confirm: {
      addToCart: `確認後加入購物車`,
      checkNotes: {
        addToCart: `確認注意事項並加入購物車`
      }
    }
  },
  cartError: {
    productNotOrderable: `商品還在準備中`
  },
  category: {
    largeCategoryDescription: (largeCategory: string) =>
      `可先上網購買日本人氣知名${largeCategory}，來日本旅行時便能於指定機場領取購買的商品。利用完美行購物，讓來日本旅行時能以更輕鬆的方式、更划算的價格購買日本伴手禮。`,
    middleCategoryDescription: (middleCategory: string, largeCategory: string) =>
      `可先上網購買日本人氣知名${middleCategory} ${largeCategory}，來日本旅行時便能於指定機場領取購買的商品。利用完美行購物，讓來日本旅行時能以更輕鬆的方式、更划算的價格購買日本伴手禮。`,
    middleCategoryMetaTitle: (middleCategory: string, largeCategory: string) =>
      `日本必買${middleCategory}・${largeCategory}`,
    popularSmallCategory: `人氣小分類`,
    showVendorOnlyDrug: `SUGI藥局 川口戶塚店`,
    smallCategoryDescription: (smallCategory: string, middleCategory: string) =>
      `可先上網購買日本人氣知名${smallCategory} ${middleCategory}，來日本旅行時便能於指定機場領取購買的商品。利用完美行購物，讓來日本旅行時能以更輕鬆的方式、更划算的價格購買日本伴手禮。`,
    smallCategoryMetaTitle: (smallCategory: string, middleCategory: string) =>
      `日本必買${smallCategory}・${middleCategory}`,
    title: `分類`,
    meta: {
      description: (categoryName: string) =>
        `${categoryName}的日本免稅商品。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
      title: (categoryName: string) => `${categoryName}的日本免稅商品一覽`
    }
  },
  categoryRanking: {
    seeMore: `查看更多排行`,
    title: `分類排行`
  },
  commons: {
    after: (time: string) => `${time}後 (日本時間)`,
    afterShipping: `出貨後`,
    all: `全部`,
    autoApplyDiscountOnAddToCart: `加入購物車後將自動適用優惠`,
    autoApplyDiscountOnAddToCartDesc: `加入購物車後將自動適用優惠。亦可與其他優惠券合併使用`,
    automaticCancel: (time: string) => `${time}後 (日本時間)將自動取消`,
    before: `之前`,
    beforeShipping: `出貨前`,
    bestJapanese: `日本必買`,
    cancelFee: `取消費`,
    choice: `選擇`,
    cosmetics: `護膚、化妝品`,
    dateAndTime: (year: string, month: string, day: string, hour: string, minute: string) =>
      `${year}年${month}月${day}日 ${hour}:${minute}起`,
    dismiss: `關閉`,
    download: `下載`,
    errorOccurred: `發生錯誤`,
    exclamationMark: `！`,
    foldContents: `收起`,
    goBack: `回到上一頁`,
    hot: `人氣`,
    lessThan: `以下`,
    mustBuy: `日本推薦`,
    noShow: `未取消且未取貨。`,
    ok: `OK`,
    pinchOut: `用雙指放大`,
    proceed: `繼續`,
    purchaseTaxFree: `以免稅價格購買`,
    qualities: `特色`,
    quantity: `數量`,
    remove: `移除`,
    showMore: `檢視更多`,
    showMoreDetails: `立即查看`,
    signUp: `註冊`,
    snacks: `點心零食`,
    specialDeals: `優惠資訊`,
    tax: `含稅`,
    taxFreeProducts: `免稅商品`,
    taxFreeRegularPrice: `一般價格（免稅）`,
    taxFreeSalePrice: `優惠價格（免稅）`,
    taxProducts: `課稅商品`,
    topPage: `首頁`,
    tryAgain: `請從頭再試。`,
    undisclosed: `不公開`,
    until: (time: string) => `${time}為止 (日本時間)`,
    vendor: `供應商`,
    wamazingShop: `完美行購物`,
    yen: `日圓`,
    aboutWamazingShop: {
      desc: `使用設置於日本全國車站及機場等地的置物櫃型自動販賣機，即可於回國前輕鬆領取商品。`,
      title: `完美行購物是什麼？`
    },
    campaign: {
      seeMoreDetail: `查看優惠活動詳情`
    },
    date: {
      day: `日`,
      month: `月`,
      year: `年`
    },
    meta: {
      title: `赴日旅遊就到完美行購物輕鬆購買日本免稅伴手禮｜完美行購物`
    },
    notice: {
      notContainKobayashiPharmaceuticalBeniKoji: `完美行購物網站上所銷售的商品，皆未使用近期報導中指出有害健康的小林製藥紅麴原料。`
    },
    url: {
      copied: `已複製網址`
    }
  },
  complementary: {
    addNToCart: (count: number) => `將${count}件商品放入購物車`,
    addToCart: `放入購物車`,
    count: (count: number) => `共計${count}件`,
    title: `經常一起購買的商品`,
    viewDetail: `查看詳情`
  },
  counterPickup: {
    jttpRemark: `完美行購物目前不支援JTTP。`,
    vjmGuideUrl: `https://services.digital.go.jp/zh-cmn-hant/visit-japan-web/guide/`,
    vjmRemark: (className: string, childClassName: string, url: string) =>
      `如欲在指定設施領取免稅商品，<span class=${className}>必須在入境日本後<a class=${childClassName} href=${url} target="_blank">註冊VJW（Visit Japan Web）</a></span>`,
    guide: {
      cancellationPolicy: {
        description: `預約時支付的20%購買金額即視為取消手續費。若選擇當面取貨，由於訂購時已支付全額，取消訂單時將退還80%的款項。`,
        refund: {
          description: `若符合退款條件，系統將於取消訂單時立即處理退款。根據選擇的付款方式，實際收到退款可能需要一些時間。款項將透過您使用的付款方式退回。`
        }
      },
      caution: {
        text1: `確認取貨機場\n是否正確`,
        text2: `確認取貨日期`,
        text3: `ロッカー受け取りの場合、パスポートを\n忘れないこと`,
        text4: `確保能\n連線至網路`,
        title: `注意事項`
      },
      counter: {
        help: {
          description: `將由客服人員提供協助`,
          descriptionDetail: (className: string) =>
            `若在取貨時遇到問題，請讀取工作人員出示的諮詢用<span class=${className}>QR Code</span>，或透過以下網址（https://tw.wamazing.com/kaimono/pickup_support）洽詢完美行<span class=${className}>客服人員</span>。`,
          title: `如果在當面取貨遇到問題時...`
        },
        step1: {
          description1: (className: string) =>
            `請事先<span class=${className}>註冊</span>Visit Japan Web並建立<span class=${className}>免稅QR Code</span>，以便當面取貨時辦理免稅手續。`,
          description2: `什麼是Visit Japan Web？`,
          description3: `查看Visit Japan Web使用流程`,
          title: `入境日本前請先註冊Visit Japan Web（VJW）`
        },
        step2: {
          description: (className: string) =>
            `指定<span class=${className}>取貨地點</span>、<span class=${className}>日期</span>及<span class=${className}>時間</span>`,
          title: `選擇取貨地點`,
          button: {
            title: `當面取貨地點一覽`
          }
        },
        step3: {
          description1: `請於取貨前建立免稅QR Code`,
          title: `於Visit Japan Web建立免稅QR Code`,
          button: {
            title: `查看建立免稅QR Code的方式`
          }
        },
        step4: {
          description: (className: string) =>
            `取貨時請向工作人員出示「取貨用QR Code」及步驟3建立的「免稅QR Code」，即可領取商品。\n可透過「我的頁面」中的「訂單一覽」確認「取貨用QR Code」。\n如有任何疑問，請直接聯繫完美行<span class=${className}>客服中心</span>，而非詢問現場工作人員。`,
          title: `領取商品`
        }
      },
      customerSupport: {
        description: `如因突發狀況等導致無法領取商品，將提供全額退款。詳情請聯繫完美行客服中心。\n※此退款保證不適用於因個人因素取消訂單者。如遇大眾交通工具誤點導致無法取貨，請提供誤點證明以辦理退款。`,
        heading: `退款保證說明`,
        subHeading: `首次使用也無需擔心`,
        title: `萬一無法成功取貨，將全額退款！`
      },
      faq: {
        message1: `取貨時需要準備什麼？`,
        message10: `本公司的置物櫃皆設置於車站或是機場大樓內。\n所有取貨手續皆須於通過安檢處前（出境前）完成。\n建議在辦理登機手續前，前往置物櫃取貨。\n※若是在入境時取貨，完成入境手續後即可領取商品。\n※若購買商品中包含超過100ml的液體，建議托運行李。\n\n詳細取貨地點以及相關手續請參考下方網址。\n<a href="https://tw.wamazing.com/kaimono/guide ">https://tw.wamazing.com/kaimono/guide </a>\n※取貨時需掃描晶片護照及有效的入境許可證。`,
        message11: `在取貨置物櫃前完成付款手續後，發現該置物櫃中並未被放入商品時，該怎麼辦？`,
        message12: `非常抱歉造成您的困擾。我們將以退費或郵寄的方式將商品寄送到您的住址，煩請洽詢完美行客服。\n<a href="https://tw.wamazing.com/kaimono/support">https://tw.wamazing.com/kaimono/support</a>`,
        message2: `【在置物櫃取貨時】\n取貨時需進行臉部辨識與核對本人身份，請務必備妥下列物品。\n\n①預約者本人的晶片護照（無法使用他人護照取貨），如未持有晶片護照將無法取貨。\n\n②入境許可證\n※入境日本時將貼於護照上\n※若為機組人員、轉機旅客或是持有日本在留資格者，且入境日本時未被貼上「入境許可證」（含JTTP日本受信賴旅客計劃），則無法使用置物櫃取貨服務。\n\n③結帳時需連接網路，請務必準備能夠上網的手機。\n\n【當面取貨時】\n①Visit Japan Web的免稅QR Code\n請事先建立免稅QR Code。\nhttps://services.digital.go.jp/zh-cmn-hant/visit-japan-web/guide/　\n\n②取貨時需連接網路，請務必準備能夠上網的手機。`,
        message3: `若超過預約取貨時間仍未完成取貨時，會怎麼樣？`,
        message4: `超過取貨時間仍未完成取貨時，訂單將被取消。取消後，將產生取消費用，且將無法領取商品，敬請留意。`,
        message5: `可以在預約取貨時間之外的時間取貨嗎？`,
        message6: `非常抱歉，無法於預約取貨時間之外的時間取貨。`,
        message7: `可以在回國日以外的時間取貨嗎？`,
        message8: `可以，只要是在日本國內的期間皆可取貨，但請務必遵守您所選擇的取貨時間。`,
        message9: `取貨置物櫃在哪裡？是在過海關前？還是在出境大廳呢？`,
        title: `常見問題`
      },
      locker: {
        step1: {
          description: (className: string) =>
            `可於設置在日本全國<span class=${className}>機場、車站、巴士轉運站</span>等地的無人置物櫃，輕鬆領取商品`,
          title: `選擇取貨地點`
        },
        step2: {
          description: (className: string) =>
            `於置物櫃前，從<span class=${className}>預約頁面</span>按下預約資訊的<span class=${className}>「輸入4位數字」</span>，並輸入置物櫃螢幕上所顯示的<span class=${className}>4位數字</span>\n`,
          title: `確認QR Code`
        },
        step3: {
          description1: (className: string) => `※須為<span class=${className}>含晶片的電子護照</span>。`,
          description2: `※取貨時，請務必攜帶含晶片的電子護照以核對本人身份。`,
          title: `確認護照\n`
        },
        step4: {
          description: `於置物櫃前，從訂單頁面按下「輸入4位數字」的按鈕，並輸入置物櫃螢幕上所顯示的4位數字`,
          title: `取貨時付款`
        },
        step5: {
          description: (className: string) => `依照置物櫃觸控面板上的指示，<span class=${className}>領取商品</span>`,
          title: `領取商品`
        }
      },
      pickup: {
        title: `取貨地點`
      },
      table: {
        title: `置物櫃取貨與當面取貨的不同`,
        row1: {
          column1: `沒有`,
          column2: `有工作人員提供服務`,
          header: `是否有工作人員在場`
        },
        row2: {
          column1: `・預約時：20%\n・取貨時：80%`,
          column2: `・預約時：100%\n・取貨時：ー`,
          header: `付款方式`
        },
        row3: {
          column1: `需要`,
          column2: `不需要`,
          header: `註冊VJM`
        },
        row4: {
          column1: `・訂購者本人的晶片護照\n・入境許可證`,
          column2: `・VJW的免稅QR Code`,
          header: `取貨時所需的物品`
        },
        row5: {
          column1: `不支援`,
          header: `JTTP`
        }
      }
    }
  },
  coupons: {
    acquired: `已領取`,
    allYouCanUse: (highlight: string) => `所有人都能使用的<span class=${highlight}>優惠券</span>`,
    allYouCanUseText: `所有人都能使用的優惠券`,
    canBeUsedForJcb: `※所選優惠券僅能使用JCB信用卡。請變更信用卡，或變更／刪除優惠券。`,
    canBeUsedForWamazingProducts: `※優惠券僅適用於完美行商品。`,
    consumableLimitReached: `發放完畢`,
    coupon: `優惠券`,
    couponForEveryone: `所有人都能使用`,
    discountByAmount: (amount: number) => `優惠 ${amount} 日圓`,
    discountByRate: (rate: number) => `優惠 ${formatDigits(100 * rate)}%`,
    discountLimit: (discountLimit: number) => `最高減 JPY${discountLimit}`,
    minSettlementAmountRemark: (minSettleMent: number) =>
      `適用於折扣前金額為${commaedInteger(
        minSettleMent
      )} 日圓以上的訂單。※付款金額未滿5,000日圓時，恕無法以免稅條件購買。`,
    noCouponToUse: `沒有可使用的優惠券`,
    noMedsAlcohol: `醫藥品、酒類飲品不適用此優惠。`,
    notLogin: `登入後，即可輸入優惠券代碼`,
    notUseCoupon: `不使用優惠券`,
    note: `注意事項`,
    pickCoupon: `選擇優惠券`,
    pleaseReview: `無法使用此優惠券。請確認優惠券的使用條件。`,
    terms: `使用條件`,
    usableBeforeJst: `(日本時間) 前有效`,
    usePromoCode: `輸入優惠碼`,
    discount: {
      limit: (amount: number) => `此優惠券最多可折抵${amount}日圓。`
    },
    list: {
      pleaseLogin: `領取優惠券前，請先登入帳號。`,
      title: `優惠券一覽`,
      page: {
        description: `想以更超值的價格輕鬆購買日本全國各地特產，以及旅途中的伴手禮，就到完美行購物！`,
        title: `完美行優惠券｜完美行購物`
      }
    }
  },
  creditCard: {
    error: {
      identityAuthentication: `信用卡的付款認證失敗`,
      useAnotherCard: `請使用其他信用卡`
    }
  },
  crossSelling: {
    activity: {
      title: `東京的人氣體驗活動行程`
    },
    tickets: {
      title: `前往東京的交通方式＆超值車票`
    }
  },
  customerSupport: {
    chat: `線上諮詢`,
    description: `完美行購物常見問題。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
    title: `客戶服務`
  },
  discountNotice: {
    addToCart: (rate: number) => `已適用${rate}折優惠並加入購物車`,
    description: `加入購物車後會自動適用優惠券。\n可與其他優惠券併用。`,
    mainText: (className: string, rate: number) => `此商品<span class=${className}>可享${rate}折優惠</span>`
  },
  favorites: {
    addSelectedToCart: `將選擇的商品加入購物車`,
    addToFavorite: `加入我的最愛`,
    addedToFavorite: `已加入我的最愛`,
    isEmpty: `尚未收藏任何商品`,
    notLogin: `登入後即可使用「我的最愛」功能。`,
    removeSelectedFromFav: `將選擇的商品從我的最愛中刪除`,
    title: `我的最愛`
  },
  featured: {
    featuredCollections: `特集一覽`,
    keywords: `熱門關鍵字`,
    moreFeaturedCollections: `檢視更多特集一覽`,
    popularCosmeticSets: `完美行限定 熱銷化妝品套組`,
    recommendedFeaturedCollections: `推薦特集一覽`,
    recommendedProducts: (largeCategoryName: string) => `推薦人氣${largeCategoryName}`,
    shiseidoBestHit2023: `資生堂暢銷明星商品2023`,
    antiUVCosmeticsLP: {
      description: `「人氣化妝品哪裡買？」以免稅價就能預購最新的防曬商品。「ANESSA安耐曬」、「肌膚之鑰」、「POLA」、「SK-II」等熱銷美妝品牌一應俱全。在此要為大家介紹完美行採購專員真心推薦的化妝品。`,
      title: `日本必買抗紫外線商品特集`,
      addToCartNow: {
        title: `立刻加入購物車`
      },
      buyerComment: {
        title: `買家評論`
      },
      buyerRecommendation: {
        comment: `在接下來的季節裡，CPB的保養組合能幫助對抗紫外線與乾燥等外部壓力，讓肌膚光采動人。\nCPB集世界頂級技術於一身，是買家們大推的超人氣品牌。`,
        title: `完美行買家推薦！\n夏季保養組合`,
        product: {
          content: `肌膚之鑰 精萃光采柔潤保濕露 170ml\n肌膚之鑰 精萃光采防護精華乳 125ml\n肌膚之鑰 精萃光采激光晶露 50ml`,
          title: `【95折】 肌膚之鑰 夏季精選保養組`
        }
      },
      contentDesc: {
        setTitle: `套組內容`,
        title: `特徵`
      },
      featuredCosmeticPrimer: {
        comment: `從上底妝到對抗紫外線，簡單1步驟就能打造出自然美肌`,
        title: `2024年備受矚目的妝前乳`,
        product: {
          content: `對抗紫外線，同時提亮並修飾膚色的防曬潤色乳。\n無添加化學處方，擁有日本國內最高等級的抗UV功效`,
          title: `THREE スムースオペレーターハイパフォーマンスクリーム 01`
        }
      },
      featuredSunscreen: {
        comment: `不想曬黑就用安耐曬的金鑽防曬乳！\n雖屬防曬用乳液，但質地清爽舒適且好推開\n不會有一般防曬產品的厚重感\n也推薦在日常生活當作隔離霜使用。\n具備防水偵測機制，最適合戶外運動與休閒活動！重點是用肥皂就能卸妝。`,
        title: `紫外線防護的基礎！\n2024年備受矚目的防曬用品`,
        product: {
          content: `長時間保濕\n防水\n以肥皂即可卸除\n花香`,
          title: `ANESSA`
        }
      },
      recommendationRate: {
        title: `推薦度`
      },
      sale: {
        setTitle: `特別套組價格`,
        title: `特別價格`
      },
      saleText: {
        title: (currency: string, preDiscountPrice: number, discountAmount: number, className: string) =>
          `原價${currency}<span class=${className}>${preDiscountPrice}</span>（含稅），現在購買立刻獲得${currency}<span class=${className}>${discountAmount}</span>優惠`
      }
    },
    anti_aging: {
      short_desc: `熟齡抗老、改善細紋的日本推薦美妝保養品`,
      title: `抗老、除皺專區`
    },
    beautyAppliances: {
      subTitle: `集結最適合用來犒賞自己的日本製美容家電和美容用品。`,
      title: `最先進的美容家電＆用品`
    },
    buyersChoiceFood: {
      subTitle: `集結對日本全國瞭如執掌的完美行買家所推薦的商品。`,
      title: `買家精選（食品）`
    },
    coldSake: {
      subTitle: `盛夏時節就想來一杯！冰鎮後更美味的日本酒特輯。`,
      title: `冷酒推薦`
    },
    collagen: {
      short_desc: `添加人氣美容成分──膠原蛋白的日本美妝保養品及營養保健食品。`,
      title: `膠原蛋白產品專區`
    },
    drug: {
      adBanner: {
        title: `日本必買 市售醫藥品`
      }
    },
    drug_store: {
      short_desc: `日本藥妝店必買的人氣美妝品及零食點心`,
      title: `日本開架美妝品`
    },
    facialCleansers: {
      subTitle: `挑選讓人每次洗完臉都倍感清爽亮顏的洗面乳。`,
      title: `日本受歡迎的洗面乳`
    },
    gift: {
      subTitle: `日本特色伴手禮都在這裡。`,
      title: `送禮首選，日本伴手禮特輯`
    },
    index: {
      meta: {
        description: `優惠商品及每季精選商品特輯一覽。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`
      }
    },
    japaneseTraditionalSweetAndSnacks: {
      subTitle: `集結來自日本全國各地受歡迎的和菓子。`,
      title: `日本的傳統 和菓子`
    },
    limitedSale: {
      caveat: `目前正準備上架商品，請耐心等待。`,
      expirationConfirm: `■購買前，請詳閱商品説明`,
      expirationDate: (year: string, month: string, day: string, className: string) =>
        `請注意，本商品有指定取貨日期。<span class=${className}>「${year}/${month}/${day}」之後將不再販售，必須在前述日期前取貨。`,
      title: `限時促銷`
    },
    lotion: {
      bestLotionsToBuyInJapan: `日本必買化妝水`,
      description: `完美行小編推薦！ 日本必買化妝水 | 透過完美行購物購買日本伴手禮，來日本旅行時便能於指定機場領取購買的商品。`,
      leadSentence: `久違的日本旅行，加上適逢日圓貶值！想購物就趁現在！\n這次要介紹完美行小編推薦的「最新的優質彩妝伴手禮 ～化妝水篇～」，為大家推薦不同品牌的化妝水。不論是送禮還是自用，都趕緊來看看吧！\n其中還包含了日本限定商品，千萬別錯過囉！\n※以下純屬小編個人評價`,
      otherLotions: `其他化妝水`,
      wamazingEditorChoice: `完美行小編推薦`,
      elixir: {
        description: `此商品尚未在日本以外的國家發售，絕不能錯過！包裝比過往來得精簡，想必能受到20歲～40歲的廣大年齡層喜愛。濃稠度在系列商品中位居第一，帶有療癒花香。`,
        title: (className: string) =>
          `2022年9月全新改良！<span class=${className}>「ELIXIR BOUNCING MOISTURE LOTION 怡麗絲爾 彈潤保濕水 SP II 」</span>`
      },
      haku: {
        description: `嚮往美白就不能錯過，質地濃稠且富含美白成分，清爽並兼顧保濕，帶有淡淡的清香。`,
        title: (className: string) => `美白化妝水首推\n<span class=${className}>「HAKU」</span>`
      },
      obagi: {
        description: `送給家中年長者的首選！日本評價超高抗老保養品。質地濃稠保濕，清透好吸收，帶有讓人神清氣爽的柑橘香。因本身價位偏高，趁著日圓貶值來撿便宜吧！`,
        title: (className: string) => `高保濕力\n<span class=${className}>「Obagi X」</span>`
      },
      orbis: {
        description: `ORBIS品牌超人氣的「ORBIS U」在日本全新改版推出。僅限日本地區販售，拿來送禮準沒錯！ 質地濃稠的化妝水能充分保濕，改良過的瓶身附有三角形切口，為整體時尚加分。`,
        title: (className: string) => `日本限定！\n全新改良<span class=${className}>「ORBIS U」</span>`
      }
    },
    meta: {
      common: {
        description: `購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`
      }
    },
    mtFuji: {
      subTitle: `說到日本伴手禮就是這個！可愛的富士山周邊商品大集合。`,
      title: `富士山周邊商品特集`
    },
    nibbles: {
      subTitle: `嚴選日本下酒零食`,
      title: `配酒最佳！日本下酒零食`
    },
    pickUp: {
      title: `精選商品`
    },
    quickShip: {
      shopNow: `立即查看`,
      title: `最快送達商品`
    },
    sensitive_skin: {
      short_desc: `敏感肌膚也能安心使用的日本推薦保養品及化妝品`,
      title: `敏感肌膚保養品專區`
    },
    serums: {
      subTitle: `集結廠商所販賣的日本製優質精華液`,
      title: `日本的優質精華液`
    },
    shoppingArticle: {
      title: `購物實用資訊`
    },
    skin_whiten: {
      short_desc: `推薦日本品牌美白產品`,
      title: `美白、淡斑專區`
    },
    slug: {
      meta: {
        description: `購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`
      }
    },
    summer2023: {
      naviTitle: `2023夏季推薦商品`
    },
    summerTreats: {
      subTitle: `酷夏救贖！冰鎮後更美味的夏日甜點特輯。`,
      title: `冰鎮後更美味的夏日甜點`
    },
    sunBlockRecommendation: {
      subTitle: `對抗紫外線的措施做得夠確實嗎？完美防曬！現在開始做好防曬！`,
      title: `2024年防曬保養特集`
    }
  },
  featuredCollections: {
    allShow: `查看所有特集`
  },
  footer: {
    genuineDescription: `所有商品皆為官方正貨。`,
    genuineTitle: `正貨認證`,
    safeDescription: `提供安心、安全的服務。`,
    safeTitle: `安心・安全`,
    serviceGuide: `服務指南`,
    userAgreement: `會員使用規則`,
    weappDescription1: `立即掃描關注`,
    weappDescription2: `玩盡日本WAmazing`,
    weappTitle: `官方公眾號 `
  },
  guide: {
    attention1: `確認取貨機場\n是否正確`,
    attention2: `確認取貨日期`,
    attention3: `携帶護照`,
    attention4: `確保能\n連線至網路`,
    confirmIdentity: (className: string) => `依照置物櫃螢幕上的指示，核對<span class=${className}>本人身份</span>。`,
    confirmLocation: `確認取貨地點`,
    confirmPassport: `確認護照\n`,
    confirmQrcode: `確認QR Code`,
    description: `完美行購物使用教學。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
    dontForget: `注意事項`,
    enterFourDigitNumber: (className: string) =>
      `於置物櫃前，從<span class=${className}>預約頁面</span>按下預約資訊的<span class=${className}>「輸入4位數字」</span>，並輸入置物櫃螢幕上所顯示的<span class=${className}>4位數字</span>\n`,
    followTabletAndReceive: (className: string) => `依照置物櫃螢幕上的指示，<span class=${className}>領取商品</span>。`,
    mustBeEPassport: (className: string) => `※須為<span class=${className}>含晶片的電子護照</span>。`,
    note: `※取貨時，請務必攜帶含晶片的電子護照以核對本人身份。`,
    openQrcodeAndScanTablet: (className: string) =>
      `於置物櫃前，從<span class=${className}>預約頁面</span>打開預約資訊的<span class=${className}>「取貨用QR Code」</span>，並於置物櫃螢幕上進行掃瞄。`,
    payment: `取貨時付款`,
    receive: `領取商品`,
    title: `取貨指南`,
    notes: {
      comeInPerson: `為減少購買商品及取貨時的擁擠狀況，僅限預約購買者本人前來辦理手續，敬請配合。`,
      note1: `付款時需連線至網絡，請確保良好的網絡環境。`,
      note2: `僅限預約購買者本人可進行購買手續，並務必由本人取貨。`,
      note3: `僅限於預約購買時所指定的取貨地點和日期時間取貨，請確認地點及日期時間後再行取貨。`,
      note4: `為完成購買手續，預約購買者本人需出示護照及護照上的入境許可貼紙，請務必攜帶同護照取貨。僅限含晶片的電子護照，以及有效期限內的入境許可貼紙。`,
      note5: `為完成購買手續，需拍攝預約購買者本人的臉部照片，敬請理解。拍攝臉部照片只為確認與護照本人是否一致，核對完畢後將立刻刪除照片。`,
      note6: `為完成購買手續，預約購買者本人需登入本公司帳戶後再進行付款。如預約購買者本人使用其他帳戶登入，將無法付款，敬請留意。`,
      note7: `如不能遵守以上任何一項，將無法完成購買手續，敬請留意。`,
      other: `其他`,
      readFollowingNotes: `關於購買及領取商品的手續，請事先確認以下事項。`,
      title: `注意事項`
    },
    page: {
      title: `使用教學`
    }
  },
  index: {
    BeautyEquipmentsRecommendation: {
      subTitle: `超人氣的抗衰、提拉緊緻美容儀器。`,
      title: `美容儀器`
    },
    babyProductsRecommendation: {
      subTitle: `奶粉、副食品等嬰兒用品大集合`,
      title: `日本人氣嬰兒用品`
    },
    dhcRecommendation: {
      subTitle: `維他命和膠原蛋白等受歡迎的DHC保健食品`,
      title: `DHC保健品`
    },
    healthFoodRecommendation: {
      subTitle: `日本人氣美容、瘦身健康食品。`,
      title: `人氣健康食品`
    },
    maskRecommendation: {
      subTitle: `嚴選人氣面膜，呵護肌膚，每天保有好心情。`,
      title: `面膜推薦`
    },
    matchaRecommendation: {
      subTitle: `說到日本就想到抹茶！\n人氣抹茶商品大集合`,
      title: `人氣抹茶伴手禮`
    },
    omiyageRecommendation: {
      subTitle: `人氣點心伴手禮,拿來送禮最合適！`,
      title: `精選點心伴手禮`
    },
    popularRecommendation: {
      subTitle: `口碑極佳嚴選商品，必買清單。`,
      title: `必買清單`
    },
    shiseidoBestHit2023: {
      subTitle: `絕不能錯過的日本殿堂級化妝品。`,
      title: `資生堂暢銷明星商品2023`
    },
    snacksRecommendation: {
      subTitle: `嚴選日本限定的美味零食，拿來送禮最合適！`,
      title: `必買點心零食`
    },
    snacksSetRecommendation: {
      subTitle: `必買人氣零食組合，拿來送禮最合適！`,
      title: `人氣組合包`
    },
    summer2023Recommendation: {
      subtitle: `2023夏季家庭出遊的推薦商品特輯`
    }
  },
  issuedCoupon: {
    checkCouponNow: `立即查看優惠券`,
    couponHasBeenIssued: (className: string) =>
      `成功領取優惠券。\n可透過<span class=${className}>購物車頁面中的「選擇優惠券」</span>來查看優惠券。`
  },
  localSouvenirs: {
    area: {
      suffix: `地區`,
      title: (area: string) => `${area}伴手禮`
    },
    aside: {
      left: {
        title: `内容`
      }
    },
    buyerComment: {
      title: {
        full: `本月官方精選`,
        row1: `本月`,
        row2: `官方精選`
      }
    },
    buyerPickUpsByRegion: {
      title: {
        full: `日本全國官方推薦精選`,
        row1: `日本全國官方推薦`,
        row2: `精選`
      }
    },
    buyerRecommendedMaker: {
      title: {
        full: `本月精選廠牌`,
        row1: `本月`,
        row2: `精選廠牌`
      }
    },
    hokkaidoTohoku: {
      description: `在北海道、東北地區的遼闊大自然和寒冷氣候下，孕育出豐富的美食！由於北海道的農業和酪農業興盛，出產了許多馬鈴薯和乳製品伴手禮。至於山形、岩手和宮城等地所在的東北地區，則有充滿在地魅力的靈魂料理，以及特色各異的日本酒。\n`,
      title: `北海道、東北`
    },
    japan: {
      description1: `來自日本全國各地的伴手禮大集合！`,
      description2: `在線上免稅店「完美行購物」，可事先於網路上購買日本全國各地的伴手禮，再到日本各地的機場或車站取貨！\n快來找找有興趣的當地伴手禮吧♩`,
      navi: `日本全國伴手禮大集合`,
      title: `日本全國 伴手禮大集合`
    },
    kansaiChushikoku: {
      description: `關西、中國與四國地區泛指大阪、京都、奈良，以及圍繞瀨戶內海的廣島及四國（香川、愛媛、德島、高知）等地。由於瀨戶內海一帶的氣候溫和且具備豐富海產資源，因此以海鮮打造的伴手禮，以及用當地名產「檸檬」製作的伴手禮非常有名！`,
      title: `關西、中國與四國`
    },
    kantoKoshinetsu: {
      description: `由於分佈了東京和神奈川等多個觀光勝地，因此到訪關東甲信越地區的訪客絡繹不絕。當地有許多好吃又好看、忍不住想買來送人的伴手禮！而在日本首屈一指的大米產地「新潟」，亦有不少令日本人愛不釋手的在地美酒。`,
      title: `關東甲信越`
    },
    kyushuOkinawa: {
      description: `九州、沖繩地區泛指福岡、熊本、鹿兒島及沖繩等地。九州有不少以當地特產「明太子」所製成的零食和蒸餾酒「燒酎」。沖繩則有以當地生產的黑糖和鹽製做的零食，以及「金楚糕」等各式充滿在地特色的伴手禮。`,
      title: `九州、沖繩`
    },
    maker: {
      aokiSofuan: {
        description: `青木松風庵是1983年創業於大阪的老字號和菓子店。商品中又以「月化粧」最受歡迎，如今已成為大阪的經典伴手禮。嚴選使用當地食材，並結合了創新與傳統技術，商品廣受各年齡層的喜愛。店內設計簡約高雅，部分店鋪還有附設咖啡區。招牌商品「月化粧」以關西地區為主要銷售據點。青木松風庵也積極協助地區發展，熱心參與在地活動，並開發使用地方食材的商品。`,
        title: `青木松風庵`
      },
      obusedo: {
        description: `老字號和菓子店「小布施堂」位於長野縣小布施町，當地是著名的栗子產地，該店使用優質栗子製作的和菓子極具魅力。其中又以栗鹿子及蒸栗羊羹最受歡迎，在此可以欣賞優美的街景，並品嚐當季或店舖限定的商品。此外還可以在附設的咖啡廳和餐廳內，品嚐以當地食材製成的甜點和餐點。來此一遊可以感受創業至今約400年的歷史與文化，體驗溫暖真摯的款待。`,
        title: `小布施堂`
      }
    },
    page: {
      description: `線上免稅店「完美行購物」集結了來自日本全國各地500種以上的在地伴手禮，從「超人氣經典伴手禮」到「只能在當地買到的地區限定商品」應有盡有。只要事先預購，即可在車站或機場取貨！不用擔心搶購一空，無需辛苦排隊。快來看看完美行採購員走遍日本各地嚴選的「每月推薦商品」以及「熱銷排行榜」，了解最新的日本伴手禮，感受旅遊樂趣吧！`,
      title: `稱霸47都道府縣！完美行官方嚴選，日本必買商品全日本伴手禮大集合！`
    },
    prefecture: {
      aichi: `愛知`,
      akita: `秋田`,
      aomori: `青森`,
      chiba: `千葉`,
      ehime: `愛媛`,
      fukui: `福井`,
      fukuoka: `福岡`,
      fukushima: `福島`,
      gifu: `岐阜`,
      gunma: `群馬`,
      hiroshima: `廣島`,
      hokkaido: `北海道`,
      hyogo: `兵庫`,
      ibaraki: `茨城`,
      ishikawa: `石川`,
      iwate: `岩手`,
      kagawa: `香川`,
      kagoshima: `鹿兒島`,
      kanagawa: `神奈川`,
      kochi: `高知`,
      kumamoto: `熊本`,
      kyoto: `京都`,
      mie: `三重`,
      miyagi: `宮城`,
      miyazaki: `宮崎`,
      nagano: `長野`,
      nagasaki: `長崎`,
      nara: `奈良`,
      niigata: `新潟`,
      oita: `大分`,
      okayama: `岡山`,
      okinawa: `沖繩`,
      osaka: `大阪`,
      saga: `佐賀`,
      saitama: `埼玉`,
      shiga: `滋賀`,
      shimane: `島根`,
      shizuoka: `靜岡`,
      tochigi: `栃木`,
      tokushima: `德島`,
      tokyo: `東京`,
      tottori: `鳥取`,
      toyama: `富山`,
      wakayama: `和歌山`,
      yamagata: `山形`,
      yamaguchi: `山口`,
      yamanashi: `山梨`
    },
    region: {
      chugoku: `中國`,
      hokkaido: `北海道`,
      hokuriku: `北陸`,
      kansai: `關西`,
      kanto: `關東`,
      kyushu: `九州`,
      okinawa: `沖繩`,
      shikoku: `四國`,
      tohoku: `東北`,
      tokai: `東海`,
      airport: {
        chugoku: `廣島機場`,
        hokkaido: `新千歲機場`,
        hokuriku: `null`,
        kansai: `JR關西機場站`,
        kanto: `JR成田機場站 \nJR成田第2大樓站\n羽田機場T3站`,
        kyushu: `天神巴士總站\nJR博多站`,
        okinawa: `那霸機場`,
        shikoku: `null`,
        tohoku: `仙台機場`,
        tokai: `中部國際機場`
      },
      description: {
        chugoku: `中國地區的魅力在於得益於溫暖氣候的豐富食材，以及各種特色料理。不論是廣島的廣島燒、尾道拉麵，還是岡山的白桃、麝香葡萄，全都是極品美食。此外，島根的出雲蕎麥麵和山口的河豚生魚片都是代表當地的特色佳餚。甜點伴手禮也有廣島的楓葉饅頭、岡山的吉備糰子等多樣選擇。這些新鮮的海產及肥沃土地孕育出的飲食文化，深深地擄獲了旅人們的心。`,
        hokkaido: `北海道憑藉雄偉的大自然，以及其自然環境所孕育出的極品美食擄獲全球旅人的心！也因為擁有新鮮且優質的農產品、乳製品、海鮮以及酒類，自古以來在日本負有「食材寶庫」的盛名。其中又以蔬菜水果、濃醇的乳製品以及新鮮的海產尤為好評，日本酒及啤酒也因為充滿在地風味而廣受喜愛。`,
        hokuriku: `北陸地區的漁獲新鮮且種類豐富，尤其又以富山的螢火魷及福井的越前蟹、石川的紅鱸魚等高級海產聞名，這些海鮮自古以來就是廣為人知的北陸特產。此外，北陸也因爲水質優異而成為知名的日本酒產地。本地釀酒歷史悠久，以講究工法釀製而成的日本酒，特別顯得口感圓潤、香氣醇厚。北陸地區又以豐富且多樣的和菓子出名，諸如添加金澤金箔的奢華和菓子，或是福井的羽二重餅都很受歡迎。\n\n`,
        kansai: `關西地區豐富的「歷史」與深厚的文化背景，對料理也產生了深遠的影響。特別是以京都為中心所發展的「抹茶」，伴隨著茶道文化的發揚，也誕生出許多美味的甜點。使用抹茶製成的和菓子和西式甜點種類繁多，還可從中感受古都風情。這種兼容並蓄正是關西飲食文化的最大魅力。\n此外，在京都的伏見和兵庫的灘一帶，自古以來便使用清澈好水及優質酒米，釀造高品質的日本酒，因而成為名聞遐邇的日本酒產地。`,
        kanto: `在關東地區可以大啖各種東京傳統的「江戶前料理」，諸如江戶前壽司、天婦羅、蕎麥麵等美食。此外，東京擁有築地市場及豐洲市場等大型的魚市場，來自全日本的新鮮漁獲皆匯集於此，因此也能品嚐鮮美的海產。東京是風貌多樣的城市，在這裡誕生了許多新穎的甜點及伴手禮，但在銀座及淺草等地區也仍保有眾多和菓子老店，新舊美味兼容並蓄。`,
        kyushu: `九州是美食的天堂，在此可品嚐各式各樣的特色美食。像是福岡的博多拉麵、大分的雞肉天婦羅、鹿兒島的黑豬肉都極具人氣。水果與甜點種類也非常豐富，諸如福岡的「甘王草莓」和長崎的「長崎蛋糕」都名聞全日本。而這裡自古以來是廣為人知的燒酒產地，如今燒酒儼然已成為九州酒類的代表！`,
        okinawa: `透過沖繩的飲食文化，可以感受其豐富的自然環境與獨特的文化。苦瓜炒什錦、花生豆腐、沖繩排骨麵等料理充分活用在地食材，堪稱極品。熱門伴手禮則有使用島辣椒製成的零食，以及紫薯塔、金楚糕！此外，提到沖繩自然就會想到「泡盛」，說明了其作為酒類產地的獨特性。`,
        shikoku: `四國地區的特色在於活用豐富自然環境及溫暖氣候所生產的食材。高知的炙燒鰹魚、愛媛的新鮮鯛魚料理、香川的讚岐烏龍麵、德島的阿波尾雞等等，各地都有獨特的料理等待遊客品嚐。此外，蜜柑及醋橘等柑橘種類豐富，新鮮濃厚的風味只能到當地品嚐。能夠品味各個地區所孕育出的在地風味，且富有傳統的飲食文化正是四國的魅力。`,
        tohoku: `東北地區因位於日本東北部而得名，擁有種類豐富的美味海產、稻米及發酵食品。在此可以品嚐新鮮的牡蠣及扇貝，還有「烤米棒鍋」、「碗子蕎麥麵」等傳統鄉土料理。此外、此地區也以釀造日本酒聞名，孕育了許多美味的在地酒款。本地區的自然資源也非常豐富，是知名的櫻桃及蘋果產地。`,
        tokai: `東海地區的美食魅力非常多元。其魅力在於匯集了各種活用各地特產的極致料理，例如名古屋的極品「味噌豬排」、香氣撲鼻的「鰻魚飯三吃」，再加上充滿靜岡風情的關東煮等等。放眼日本，名古屋也以獨樹一格的獨特飲食文化著稱，誕生出像是名產「小倉紅豆吐司」這樣的熱賣商品。走訪此地區時，千萬別忘了品嚐這裡豐富多彩的美食。\n`
      },
      label: {
        chugoku: `中國・四國`,
        hokkaido: `北海道・東北`,
        hokuriku: `東海・北陸`,
        kansai: `關西`,
        kanto: `關東`,
        kyushu: `九州・沖繩`,
        okinawa: `九州・沖繩`,
        shikoku: `中國・四國`,
        tohoku: `北海道・東北`,
        tokai: `東海・北陸`
      }
    },
    relatedArticles: {
      title: {
        full: `伴手禮相關推薦文章`,
        row1: `伴手禮相關`,
        row2: `推薦文章`
      }
    },
    souvenirRanking: {
      title: {
        full: `日本全國伴手禮排行榜`,
        row1: `日本全國`,
        row2: `伴手禮排行榜`
      }
    },
    tokaiHokuriku: {
      description: `東海、北陸地區泛指名古屋所在的愛知縣、靜岡縣，以及充滿日本文化色彩的石川縣（金澤市）和富山、福井等地。北陸地區因嚴寒氣候和豐富的水資源，而具備了得天獨厚的製酒環境，因此當地的日本酒也是相當優質！`,
      title: `東海、北陸`
    }
  },
  lp: {
    mediaCoupon: {
      goToTop: `回首頁`,
      goToWAmazing: `前往完美行購物`,
      faq: {
        a1: `非常抱歉，已成立的訂單將無法變更取貨時間，請取消後再次重新購買。`,
        a2: `醫藥品（供應商： SUGI藥局）非免稅商品。僅購買醫藥品時，需另外購買滿3,000日圓。`,
        a3: `非常抱歉，如未持有晶片護照的話，將無法進行取貨。`,
        a4: `依據法律規定將無法辦理免稅手續，因此無法進行取貨。`,
        label: `常見問題`,
        q1: `可以更改取貨日期嗎？`,
        q2: `醫藥品也是免稅商品嗎？`,
        q3: `若未持有晶片護照，能夠進行取貨嗎？`,
        q4: `若取貨人並非護照持有人時，能進行取貨嗎？`,
        q5: `有哪些付款方式呢？`,
        a5: {
          aftee: `AFTEE先享後付`,
          detail1: `付款方式為線上刷卡，支援VISA、Mastercard、JCB、美國運通卡。`,
          detail2: `使用wechatpay付款的用戶， 於取貨或支付餘額時也須使用wechatpay`,
          detail3: `亦可使用超商付款、ATM、電子錢包（AFTEE先享後付）付款。`
        }
      },
      footer: {
        app: `從這裡下載APP`,
        enjoy: `盡享日本樂趣的精彩人生`,
        wamazing: `完美行購物`
      },
      hero: {
        subtext1: `日本人氣伴手禮`,
        subtext2: `線上`,
        subtext3: `在機場領取`,
        subtitle: `不用再去免稅櫃台排隊了！`,
        text1: `品項豐富`,
        text2: `預約`,
        text3: `伴手禮`,
        title: `讓您更加享受\n旅行及購物的\n線上免稅店`
      },
      how: {
        goToTop: `使用優惠券來體驗購物吧`,
        label: `超值優惠券使用方法`,
        labelWithPrice: (price: string) => `${price}日圓優惠券的使用方式`,
        labelWithRate: (rate: number) => `${formatDigits(100 * rate)}%優惠券的使用方式`,
        list1: `於發放頁面取得優惠券`,
        list1Click: `點擊以下領取優惠券`,
        list2: `將商品加入購物車`,
        list3: `確認購物車內容`,
        list4: `於購物車畫面按下「詳細金額」內的「選擇優惠券」`,
        list5: `輸入从１複製的優惠券代碼後按下「OK」`,
        list6: `畫面將顯示優惠券請勾選並按下「選擇」`,
        list7: `優惠券抵用成功！`,
        notice1: `※如欲使用優惠券，需於同一供應商<strong>消費金額達「5,000日圓以上」，方符合適用條件</strong>。購物滿5,000日圓以上即<strong>符合免稅條件</strong>，請在享受購物樂趣的同時，留意「<strong>供應商</strong>」資訊。`
      },
      introduction: {
        feature1: `於旅行前下單`,
        feature2: `在機場取貨`,
        feature3: `自助免稅`,
        forWamazing: `完美行購物提供\n<em>事前預約購買</em>商品，\n於<em>日本機場</em>\n<em>取貨的服務</em>。`,
        introText: `首創新型態線上免稅店購物服務`
      },
      notice: {
        label: `重要須知`,
        notice1: {
          text1: `部分熱門商品可能會有供貨不足的情況，`,
          text2: `屆時供應商需要較長時間備貨，`,
          text3: `敬請見諒。`
        },
        notice2: {
          text1: `還在考慮的人`,
          text2: `趕緊把握機會下單購買吧。`
        }
      },
      problem: {
        list1: `旅行中<em>提著大包小包相當不便</em>`,
        list2: `要顧小孩又要顧行李<em>很麻煩</em>`,
        list3: `搭電車或走在路上都快<em>撞到</em>其他人`,
        list4: `投幣式置物櫃<em>永遠是滿的</em>`,
        list5: `<em>辛苦找尋</em>有賣商品的<em>店家</em>`,
        list6: `為了挑伴手禮在回程機場<em>匆匆忙忙...</em>`,
        list7: `想到時間有限就<em>無法享受</em>購物樂趣`,
        list8: `沒想到在<em>伴手禮上花這麼多錢</em>`,
        more: `明明想好好享受觀光，`,
        note1: `就讓我們來協助您解決煩惱`,
        note2: `讓日本之旅留下美好回憶`,
        strong: `卻有這樣的煩惱嗎？`,
        point: {
          subject: `完美行購物`,
          subtext1: `找伴手禮的時間`,
          subtext2: `拍照留念`,
          subtext3: `因為免稅`,
          text1: `節省`,
          text2: `輕鬆`,
          text3: `買到賺到`
        }
      },
      safety: {
        label: `完美行購物的三大安心`,
        subtitle: `本公司販售之商品皆為正規商品。`,
        title: `關於正規商品`,
        list1: {
          text: `在SUGI藥局的醫藥品銷售指導下進行販售。`,
          title: `關於醫藥品`
        },
        list2: {
          text: `我們致力保護使用者的隱私權及安全性。`,
          title: `個人資訊保護政策`
        }
      },
      showProducts: {
        add: `人氣商品陸續增加中！`,
        find1: `線上購物方便瀏覽想買、`,
        find2: `想要的商品`,
        label: `省去尋找商品的時間和不便`,
        title1: `上架商品<em>超過1萬種！</em>`,
        title2: `日本各地商品齊全`
      },
      unique: {
        label: `和在機場購物不同之處`,
        list1: {
          text: `不必再花時間去大排長龍的免稅櫃台。`,
          title: `不用再去免稅櫃台排隊`,
          type: `無需\n排隊結帳`
        },
        list2: {
          text: `部分商品價格可能包含<em>免稅手續費</em>。`,
          title: `不含手續費`,
          type: `手續費`
        },
        list3: {
          text: `提供許多充滿特色的日本商品。`,
          title: `品項豐富`,
          type: `日本特色`
        },
        list4: {
          text: `販售美妝、零食、醫藥品及動漫周邊等多種商品。`,
          title: `上架商品種類豐富`,
          type: `還有動漫\n周邊`
        }
      },
      userGuide: {
        label: `不再錯過按下快門的時機`,
        subtitle: `「解放雙手享受旅行」`,
        title: `不用再拿一堆伴手禮`,
        guide: {
          icon1: `巴士轉運站`,
          map1: `<em>日本各地共11個地點</em>提供取貨！\n取貨置物櫃設置於主要城市的機場或車站內`,
          multi: `提供多種語言服務讓您安心使用`,
          step1: `自旅行<em>前3個月</em>到取貨日<em>3天前</em>都能訂購！\n下單時可指定欲取貨的機場。`,
          step2: `使用<em>護照</em>、<em>入國許可證</em>取貨。`,
          step3: `拿著伴手禮回國。\n或是繼續享受觀光。`,
          support: `操作取貨置物櫃如任何疑問\n請<em>透過QR Code</em>聯絡客服中心`,
          text: `完美行購物使用教學`,
          threeMins: `取貨時間 約3分鐘`,
          title: `從下單到取貨簡單3步驟`
        }
      },
      voice: {
        label: `來自使用者的評價`,
        list1: `可以在這裡一次買到不同品牌、店家的點心零食，輕鬆達到免稅門檻。不僅如此，商品種類也很豐富。`,
        list2: `到日本後沒有什麼購物的時間，所以事先在完美行購物買好了，真的超方便！`,
        list3: `看到「不必在旅途中提著大包小包」這句話，覺得很方便。`,
        list4: `非常感謝客服人員盡力協助解決問題，以後有機會的話也會想再使用完美行的相關服務。`
      }
    },
    serviceIntroduction: {
      returnToSnow: `返回完美行滑雪`,
      snowHero: {
        title: `讓你更加享受\n滑雪之旅的\n線上免稅店`
      },
      snowProblem: {
        list1: `提著滑雪裝備<em>移動相當不便</em>`,
        list2: `為了幫別人代購伴手禮<em>而到處找尋商品</em>`,
        list3: `花時間<em>排隊結帳、辦理免稅手續</em>`,
        more: `想要好好享受單板、雙板滑雪的時光，`,
        note: `讓滑雪之旅留下美好回憶`,
        strong: `卻有這樣的困擾嗎？`
      }
    }
  },
  lunarNewYearSale: {
    drugDiscount: (className: string) => `全品項<span class=${className}>8</span>折`,
    metaDescription: `【免稅9折➕最高25折】新春活動限定的眾多超值商品！`,
    metaTitle: `完美行新春活動開跑`
  },
  maker: {
    maker: `生產廠家`
  },
  mypage: {
    title: `我的頁面`
  },
  nativeApp: {
    badge: {
      exclusive: `App限定優惠券發送中`,
      title: (pink: string) => `<span class=${pink}>App限定優惠券發送中</span>\nApp評分4.7／3,500則以上`,
      download: {
        count: {
          currentDate: `截至2024年9月5日`,
          text: `累積下載次數突破30萬次`
        }
      },
      rating: {
        title: `App評分4.7／3,557則`
      }
    }
  },
  orderForm: {
    addNewCard: `新增信用卡`,
    andConfirmedInput: `並確認資訊填寫無誤`,
    checkNotes: `請確認注意事項`,
    creditCard: `信用卡`,
    creditCardInformation: `付款方式`,
    dateOfBirth: `出生日期`,
    dateOfLanding: `入境日期`,
    fillDateOfBirthAsPassport: `請務必填寫護照上的「出生年月日」。`,
    firstName: `護照上的名字 (英文)`,
    iAgree: `我同意`,
    lastName: `護照上的姓氏 (英文)`,
    nameAndDateOfBirth: `姓名和出生日期`,
    notPurchaseWithoutDateOfBirthAsPassport: `若護照上沒有「出生年月日」，恕無法購買免稅商品。`,
    orderPlaced: `訂單完成`,
    passport: `護照`,
    passportInformation: `護照資料`,
    personalInformation: `個人資訊`,
    pickupContent1: `※停留日本期間內均可任意選擇取貨時間。`,
    pickupContent2: `※通常最快於購買日三天後方可取貨，建議請盡早下單。`,
    pickupDate: `取貨日期`,
    pickupIdentity: `個人資訊`,
    pickupIdentitySub: `您的個人資訊僅用於免稅服務`,
    pickupSchedule: `取貨日程`,
    pickupTime: `取貨時間(設定日期後可選擇)`,
    statusOfResidence: `在留資格`,
    supportedCreditCards: `可以利用的信用卡品牌`,
    taxFreeProcedures: `免稅手續`,
    userAgreement: `購買條款`,
    validatorMessage: {
      invalidCreditCardType: `請使用VISA, Mastercard, JCB 或 American Express。`,
      mustBeAlphaNum: (field: string) => `請以英文字母或數字輸入${field}`,
      mustBeAlphaNumSymbols: (field: string) => `請以英文字母，數字，破折號或底線輸入${field}`,
      mustBeAlphabets: (field: string) => `請以英文字母輸入${field}`,
      mustBeNum: (field: string) => `${field}請以半角數字輸入`,
      mustBeOver20: `日本法律嚴格禁止販售酒類給未滿20歲者`,
      mustNotBeEmpty: (field: string) => `請輸入${field}`,
      mustSelectCorrectValue: `請填寫正確的國籍代碼`
    }
  },
  orders: {
    actuallyPickedAt: `實際取貨時間`,
    areYouSureToCancelOrder: `真的要取消訂單嗎？`,
    autoCancelled: `自動取消`,
    autoCancelledAndCollected: (date: string, className: string) =>
      `由於已超過<span class=${className}>${date}</span>的取貨期限，訂單已被取消，商品也已退回。`,
    awaitingNextUse: `期待您再次光臨`,
    canBePickedUpUponArrival: `※可在入境時領取`,
    cancelOrder: `取消訂單`,
    cancellationFee: `取消費用`,
    cancellationFeeWillBeChargedAfter: (date: string) =>
      `若於${date}(日本時間)後取消，將扣除已支付的費用作為取消費用。`,
    cancelled: `已取消`,
    cancelledAt: `取消時間`,
    cancelledByCustomer: `已根據您的要求\n取消訂單`,
    checkReceiveMethod: `確認取貨方法`,
    checkReceivePlace: `確認取貨地點`,
    checkVjwReg: `確認VJW的註冊方法`,
    confirmPickupMethod: `確認領取點地圖及取貨方法`,
    createOrder: `建立訂單`,
    deadline: `取貨期限`,
    depositAmount: (field: number) => `訂金為${field}日圓。`,
    earliestCollectionDate: `最快可取貨時間`,
    earliestNotice: `※根據商品不同，發貨程序和出貨時間也會有所不同。`,
    firstPaid: `預約完成。`,
    goOrderDetailOfSmartPhone: `請透過手機的服務畫面，確認取貨用的QR Code，以及輸入用於支付餘額的號碼。`,
    infoForPickUp: `取貨時所需資料`,
    noCancellationFeeCharged: `無需支付取消費用`,
    note1: `※1 取貨前皆不算完成免稅手續，故收取含稅商品價格20％的預約手續費。`,
    note2: `※2 預約手續費將於取貨付款時於購買金額內抵銷。`,
    note3: `※3 應稅商品無需預約，請直接支付商品金額。`,
    openLocker1: `請先確認置物櫃編號`,
    openLocker2: (className: string) => `<span class=${className}>再取貨。</span>`,
    order: `訂單`,
    orderCancelled: `已取消訂單。`,
    orderId: `訂單ID`,
    orderPlaced: `完成訂購`,
    orderPlacedAt: `訂單建立於`,
    orderTitle: `訂購詳細`,
    payAtCounter: (amount: number, className: string) =>
      `的付款總額為<span class=${className}>JPY${commaedInteger(amount)}</span>日圓。`,
    payRemainingAmount: `請於取貨時支付餘額。`,
    paymentProcedure: `輸入4位數字`,
    pickupCompleted: `取貨已完成`,
    pickupLocation: `取貨地點在`,
    pleasePickUpBeforeDeadline: (date: string) =>
      `請於日本時間${date}前取貨。\n若未能於期限內取貨，訂單將被取消，商品也將被退回，敬請留意。`,
    qrcodeForPickUp: `確認取貨 QR Code`,
    requireInternetEnv: `※取貨時請確保手機連線至網路`,
    retrievalProblems: `無法順利取貨時，請點此處`,
    scanQrOnDevice: `請於取貨地點出示此QR Code`,
    secondPaid: `付款完成。`,
    showQrcode: `請以置物櫃鏡頭掃描此QR Code`,
    startReceive: `開始取貨`,
    thankYouForShopping: `非常感謝您的惠顧。`,
    thankYouMessage: `感謝您的使用`,
    vjwRegistered: `是的，已註冊VJW`,
    cancelPolicy: {
      Charge20: `總支付金額的20%`,
      freeCancellation: `免費取消`,
      note1: `出貨前：無需支付取消費用。`,
      note2: `出貨後：預約手續費的100%（相當於商品價格的20%（含税））`,
      note3: `未取消且未取貨：預約手續費的100%（相當於商品價格的20%（含税）））`,
      note4: `如取消訂單，本公司將根據取消政策，將客戶預約購買時所支付的預約手續費，視為取消手續費。`,
      note5: `在需要支付取消費用的情況下，已使用的優惠券將不會退還，敬請諒解。`,
      note6: `訂單內若含課稅商品，將退款課稅商品總額的80%，剩餘則作為取消手續費用。`,
      title: `取消費用政策`
    },
    haneda_shop: {
      noteForPickupLocation: (url: string, className: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${className}>羽田機場的取貨地點</a>為「單軌電車檢票口內」。`,
      noteForUsersWithoutJr: (className?: string) =>
        `※若不搭乘單軌電車前往機場，請另行<span class=${className}>購買車票</span>後，再進入檢票口。`
    },
    kansai_shop: {
      noteForPickupLocation: (url: string, className: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${className}>關西機場的取貨地點</a>為「JR關西機場站」內。`,
      noteForUsersWithoutJr: (className?: string) =>
        `※若不搭乘JR線，請另行<span class=${className}>購買車票後</span>，再進入檢票口。`
    },
    locker: {
      enter4number: `請輸入置物櫃螢幕上所顯示的4位數字。`,
      next: `下一步`,
      payAll: (amount: number, className: string) =>
        `付款總額為<span class=${className}>JPY${commaedInteger(amount)}</span>日圓。`,
      payRemainingAmount: `支付餘額`,
      paymentDetail: `付款詳情`
    },
    narita1_shop: {
      noteForPickupLocation: (url: string, linkClassName: string, boldClassName: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${linkClassName}>成田機場的取貨地點</a>為「成田機場第1航廈JR成田機場站檢票口內」。若不搭乘JR電車前往機場，請另行<span class=${boldClassName}>購買車票</span>後，再進入檢票口。`
    },
    narita2_shop: {
      noteForPickupLocation: (url: string, linkClassName: string, boldClassName: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${linkClassName}>成田機場第2航站樓的取貨地點</a>為「JR成田機場第2航站樓檢票口內」。若不搭乘JR電車前往機場，請另行<span class=${boldClassName}>購買車票</span>後，再進入檢票口。`
    },
    pickupItems: {
      note1: `僅限預約購買者本人可進行購買與取貨的手續。`,
      note2: `取貨時需出示預約購買者本人的護照。僅限含晶片的電子護照。`,
      note3: `進行購買、取貨的手續時需確保手機連線至網路。請事先備妥。`,
      title: `關於領取商品`
    }
  },
  orderstep: {
    step1: `網站上購物`,
    step2: `支付\n預約手續費`,
    step3: `取貨地付款\n並取貨`,
    title: `使用流程`
  },
  payment: {
    cardValidUntil: `有效日期`,
    creditCardHolder: `持卡人`,
    creditCardNumber: `信用卡號碼`,
    errorRegisteringCreditCard: `未能登錄信用卡`
  },
  pickupSupport: {
    cancel: `取消本次訂單`,
    cancellationFeeMayBeAdded: `亦可能需負擔取消手續費。`,
    chooseOverseasShippingOrCancellation: `選擇郵寄海外或取消訂單`,
    consumptionTaxMayBeAdded: `由於郵寄海外商品非免稅適用對象，可能需支付消費稅。`,
    contactUs: `諮詢`,
    deliver: `郵寄到府更安心`,
    deliverOrCancel: `選擇郵寄到府或取消訂單`,
    deliverOverseasOrCancel: `亦受理郵寄海外或取消訂單。`,
    flow: `手續流程`,
    note: `※亦可於返台後辦理`,
    overseasShippingCostsMayBeAdded: `亦可能需另付國際運費。`,
    pressTheButton: `點選[諮詢]按鈕查詢`,
    scanQrCode: `掃描QR code`,
    sendARequest: `填寫諮詢表格並送出`,
    sendTheProblem: `將問題傳送至客服聊天室`,
    title: `安心支援服務`,
    waitForCustomerSupport: `等待客服連絡`
  },
  popularBrand: {
    title: `人氣品牌`
  },
  product: {
    shopping: `購物`
  },
  products: {
    FromPickUpDate: (year: string, month: string, day: string, hour: string, minute: string) =>
      `${year}年${month}月${day}日${hour}:${minute}起`,
    alsoSearched: `購買本商品的顧客還搜尋了下列商品`,
    amountPaidAtReservation: `預約時所支付的金額`,
    amountPaidUponPickup: `領取商品時需支付的金額`,
    bestBefore: `賞味/使用期限`,
    bestBeforeDate: `賞味期限`,
    bookingFee: `預約手續費`,
    bookingFeeOfVendor: (vendor: string) => `${vendor}的預約手續費※1、2`,
    brand: `品牌`,
    buyerComment: `官方推薦`,
    customersAlsoSearched: `相似商品`,
    desc: `商品説明`,
    details: `詳細`,
    fastestDeliveryDate: (year: string, month: string, day: string, hour: string, minute: string) =>
      `最快送達時間 : ${year}年${month}月${day}日 ${hour}時${minute}分`,
    finalPayment: `取貨時支付額`,
    findOutMoreAboutWamazing: `了解WAmazing購物服務的特徵詳情`,
    grossWeightGram: `含包裝重量`,
    ingredients: `成分/原材料`,
    loginToAddToCart: `需先登入才能放入購物車`,
    maxOrderCountAlert: `購入可能な数に達成しているため、これ以上の注文はできません。ご了承お願いします`,
    minimumBuyPerOrder: (minimum: number) => `每單滿 ${minimum} 件即可訂購`,
    name: `商品名`,
    netContent: `內容量`,
    note1: `※根據商品不同，發貨程序和出貨時間也會有所不同，有機會能提早取貨。`,
    orderLimitPerOrder: (limit: number) => `每單限購 ${limit} 件`,
    outOfStock: `暫時缺貨`,
    pay: `支付`,
    payBookingFee: `去支付`,
    point1: (className: string) => `旅行前下單`,
    point2: (className: string) => `在機場取貨`,
    point3: (className: string) => `自助型免稅`,
    price: `價格`,
    priceOfTaxFreeMerchandise: `免稅商品的商品金額`,
    productDescription: (product: string) =>
      `免稅${product}。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
    productInfo: `商品資訊`,
    productPriceOfVendor: (vendor: string) => `${vendor}的商品金額※3`,
    reason: `特點`,
    sellingPriceTaxFree: `售價(免稅)`,
    sellingPriceTaxIncluded: `售價(含稅)`,
    shippingDeadline: (year: string, month: string, day: string) =>
      `期間限定商品，領取期限至${year}年${month}月${day}日為止`,
    shiseido: `資生堂認證網上購買`,
    showMoreServiceInformation: `查看詳細服務內容`,
    size: `尺寸`,
    stockNotification: `進貨通知`,
    stockNotificationDesc: `商品進貨通知將以電子郵件傳送至您所註冊的電子信箱。是否設定通知功能？`,
    stockNotificationNotLogin: `欲設定進貨通知，請先登入。`,
    stockNotificationRegistered: `進貨通知設定完成！`,
    stockNotificationTitle: `是否要設定進貨通知？`,
    taxFreePrice: `免稅價`,
    undiscountedPrice: `原價`,
    waitingReStock: `等待進貨`,
    whyBuyFromWAmazing: `WAmazing免稅購物的特點`,
    alcohol: {
      ageVerification: `・購買者本人是否年滿20歲？`,
      airportsWithAlcoholPickupRestrictions: `那覇機場、新千歲機場暫不提供酒類商品的取貨服務。`,
      alcoholContent: `酒精濃度`,
      confirm: `請確認\n免稅條件`,
      howToConfirm: `■確認方法`,
      ingredients: `原料`,
      japaneseLowDesc: `・日本法律規定禁止販賣酒類給未滿20歲者。`,
      pageDesc: `※因酒類的供應商(東急百貨店)與其他商品不同，購買酒類及非酒類商品時，兩類商品皆需滿5,000日圓以上才可免稅。`,
      passportAgeVerification: `※可能需出示護照以核對年齡，如購買者未滿20歲，恕無法購買酒類，敬請留意。`,
      polishingRatio: `精米步合`,
      productionArea: `產地`,
      regardingSales: `■關於酒類販賣`,
      regardingSalesDesc: (className: string) =>
        `・因酒類的供應商與其他商品不同，購買酒類商品的金額無法與非酒類商品一同計算。\n<span class=${className}>・購買酒類（東急百貨公司）與非酒類商品時，兩類商品皆需滿5,000日圓以上才可免稅。請確認各自總額符合免稅條件。</span>\n・酒類（東急百貨公司）商品的確認方法請參考下方圖示。`,
      reminderForAlcoholImportTaxExemptionLimit: `攜帶酒類入境不同國家/地區時，皆有免稅上限規定。請自行做確認。`,
      storageMethod: `保存方式`,
      taxFreeAlcoholPurchaseThreshold: `因酒類的供應商與其他商品不同，購買酒類商品時需滿5,000日圓以上才可免稅。`,
      title: `酒類`,
      yesAge20: `是，本人已年滿20歲。`,
      flavor: {
        dry: `辛口`,
        sweet: `甘口`
      }
    },
    buyerCommentLabel: {
      title: `買家精選`,
      patch: {
        text: `附評價`
      }
    },
    chemicals: {
      confirm: `請確認注意事項`
    },
    homeAppliance: {
      checkAgreement: `確認家電產品的同意事項`,
      afterSupport: {
        title: `關於產品的售後服務`
      },
      brandSpecificRemarks: {
        title: `其他品牌、商品補充事項`
      },
      contactInfo: {
        desc: `若商品有任何問題，請透過下方的諮詢表單聯繫。表單的標題請選擇「免稅購物」，謝謝。`,
        details: `本公司恕無法受理基於顧客自身原因的退貨、退款要求。\n若在正常使用情況下發生自然故障，將依照各公司的保固規定提供保固。\n若商品在保固期內，且廠商有提供國際保固服務，本公司可以提供鄰近顧客的廠商保固據點資訊。\n各家廠商的保固內容請參閱保證書。`,
        title: `諮詢處`
      },
      returnRefundPolicy: {
        desc: `若商品有出廠瑕疵，原則上會在收到退貨商品後，退回款項。\n如有需要，請務必在到貨後的10天內，透過上述聯絡方式聯繫客服。到貨的11天後恕無法受理出廠瑕疵，敬請見諒。`,
        mainTexts: `出廠瑕疵的判定由上述的客服窗口負責。屆時可能會請客戶提供影片或照片等參考資訊。※若無法提供影片或照片，可能無法進行退貨、退款處理。\n另請注意，退貨之運費需由顧客自行負擔。`,
        title: `因出廠瑕疵導致的退貨、退款`
      },
      returnRefundPolicyExtra: {
        desc: `若本公司判斷商品無瑕疵或不良等情況，恕無法辦理退款。`,
        mainTexts: `商品到貨後，恕無法受理基於顧客自身原因的退貨、退款要求。\n若商品已由顧客進行任何形式的加工，亦無法受理退貨、退款。`,
        title: `退貨、退款相關補充須知`
      },
      sendBackRepair: {
        desc: `若於商品到貨的11天以後發現瑕疵，本公司接到聯繫後將安排「維修服務」。\n本公司的「送修服務」（※註），對於仍在保固期內的商品提供免費維修。`,
        mainTexts: `惟視故障情形，有可能需要支付維修費用，敬請見諒。\n請將問題商品寄送至本公司的指定地點，將依據廠商保固內容進行維修後寄還。\n商品的寄回運費、維修後的寄還運費，均需由顧客自行負擔。\n※註：問題商品送回本公司後，進行維修等處理後寄還商品的服務方式。`,
        title: `因商品瑕疵提供的維修服務（send back）`
      },
      sendBackRepairExtra: {
        remark: `若本公司無法確認瑕疵、不良等情況，恕將無法提供維修`,
        title: `維修服務補充須知`,
        condition: {
          desc: `對於送修的問題商品，經本公司和廠商確認後，若未發現瑕疵、不良等情況，將無法提供維修服務。屆時該商品將維持現狀，重新包裝後寄還顧客，敬請見諒。（寄還運費原則上由顧客自行負擔）\n若為下述情況，即使商品仍在保固期內也需支付維修費用，敬請見諒。\n`,
          details: `遺失或維修時無法出示收據類文件、保固書等購買證明\n因不當使用（安裝）而導致的故障和損壞\n遇水、摔落或遭受外力（被腳踩踏等）而導致的故障和損壞\n改裝或非正規維修而導致的故障和損壞\n火災、地震、風災水災、雷擊或其他天災地變而導致的故障和損壞\n運送而導致的故障和損壞\n停電、雷擊、異常高電壓而導致的故障和損壞\n因設置了其他器械而導致的故障和損壞`
        }
      },
      sony: {
        desc: `在全球47個國家提供國際保固（維修服務）。收到顧客的聯繫後，本公司將告知後續處理方式。可由以下連結確認保固適用國家\n`,
        title: `SONY`
      },
      watch: {
        brandList: (
          seikoUrl: string,
          citizenUrl: string,
          seikoEpsonUrl: string,
          anchorTagClassName: string,
          listTagClassName: string
        ) =>
          `<li class=${listTagClassName}>SEIKO Watch株式會社: <a href=${seikoUrl} class=${anchorTagClassName} target='_blank'>${seikoUrl}</a>（保固期 1年）</li>\n<li class=${listTagClassName}>CITIZEN時計株式會社: <a href=${citizenUrl} class=${anchorTagClassName} target='_blank'>${citizenUrl}</a>（保固期 1年）</li>\n<li class=${listTagClassName}>精工愛普生株式會社（東方錶）: <a href=${seikoEpsonUrl} class=${anchorTagClassName} target='_blank'>${seikoEpsonUrl}</a>（保固期 1年）</li>`,
        desc: `根據廠商的保固內容提供服務。\n可由以下連結確認各家廠商的保固內容。 `,
        title: `手錶`,
        precaution: {
          mainTexts: `錶帶一經顧客自行調整，將失去保固資格。\n【自動上鍊、人動電能】手錶能藉由晃動獲取動力，進而發電、儲存電力。若長時間未使用，或一天當中的配戴時間較少，手錶便可能停止不動，或發生時間（秒針）誤差等情況。此時請先再次晃動手錶（使其發電）後確認狀態。（晃動：請搖晃手錶數分鐘）\n石英錶維修時，將使用出廠時內含的電池進行功能、性能檢測。因此該錶的電池壽命可能短於預期使用年限。\n手錶的【限定商品】和【機械錶/手動上鏈手錶】、【高價商品】，到貨後恕無法受理基於顧客自身原因的退貨要求，敬請見諒。`,
          title: `隨附注意事項`
        }
      }
    },
    medicine: {
      Ingredients: `成分・份量`,
      Inquiries: `諮詢窗口`,
      InquiriesForClick: `欲諮詢請點此處`,
      administration: `用法・用量`,
      consult: `諮詢事項`,
      contraindications: `禁止事項`,
      couponText: (rate: number) => `標示價格再享${rate}折優惠`,
      discountText: `醫藥品優惠券`,
      distributorContact: ` 商品諮詢處`,
      effects: `功效・效果`,
      notice: `※購買前，請務必詳閱「注意事項」。 \n※依據法律規定，線上購物平台販售的醫藥品（供應商：SUGI藥局 川口戶塚店）無法免稅，因此全部醫藥品皆以含稅價格販售。完美行正舉辦優惠活動，全部醫藥品在結帳時，將自動扣除稅金價格。\n※僅購買醫藥品(供應商 :SUGI藥局 川口戶塚店)時，消費總金額需滿1000日圓以上。`,
      other: `其他注意事項`,
      precautions: `保存及使用上的注意事項`,
      shelfLife: `使用期限`,
      Information: {
        desc: (category: string, className: string) =>
          `・此商品在日本被列為「${category}」。購買時請務必遵守網站上標示的<span class=${className}>「禁止事項」、「服用前須諮詢事項」及「用法、用量」，並詳閱「使用上的注意事項」後，再下單購買。</span>\n・關於醫藥品若有任何不明之處，請於購買前諮詢醫生、藥劑師或註冊經銷商。\n※本店所販售的醫藥品使用期限皆在6個月以上。\n`,
        title: `醫藥類商品販售相關說明`
      },
      abused: {
        desc: `為避免含有以下成分之醫藥品被濫用導致危害人體健康，依日本法律規定，在販售時須確認以下事項，且每人限購1盒。`,
        title: `商品內包含有濫用風險的醫藥類商品，在購買前請先詳閱以下注意事項。`,
        confirm: {
          least18years: `①購買藥品者須年滿18歲`,
          notBoughtAnyMedicine: `②在其他藥局等處未購買與此藥品具相同藥效的藥品`,
          notMadeConsecutive: `③未長期購買、服用此藥或與此藥品具相同藥效的藥品`,
          title: `■有關消費者或使用者的注意事項`
        },
        ingredient: {
          desc: `・麻黃鹼、可待因、二氫可待因、溴化纈草酸尿素、消旋鹽酸甲基麻黃鹼、偽麻黃鹼`,
          title: `■請確認內含的濫用等風險成分\n（含有以下成分的醫藥品皆為須確認對象。）`
        }
      }
    },
    notice: {
      expectedRestockDate: (year: number, month: number, day: number) =>
        `此商品預計於<em>${year}年${month}月${day}日</em>補貨`,
      restockDateUndetermined: `此商品的補貨日期<em>尚未確定</em>`,
      restockDateUndeterminedShort: `補貨日期尚未確定`,
      restockNotificationEmail: `商品補貨通知將寄送至註冊的電子信箱。`,
      restockNotificationEmailNote: `※補貨日期可能有所變動。`,
      restockNotificationSet: `已設定補貨通知`,
      restockNotificationSetup: `補貨通知設定完成`,
      scheduledArrival: (month: number, day: number) => `預計於${month}月${day}日補貨`,
      wishRestockNotification: `欲收到補貨通知`
    },
    originalPoint: {
      title: (product: string) => `${product}的原創特色`
    },
    promo: {
      labelText: `限時9折優惠`
    },
    sort: {
      popular: `熱銷排行`,
      priceAsc: `價格（低至高）`,
      priceDesc: `價格（高至低）`
    },
    tokyuStore: {
      liquorLp: {
        brewery: `酒廠`,
        description: `完美行購物與東急百貨合作，提供來自日本各地、兼具傳統與創新的酒廠所釀造的高品質日本酒。`,
        intro: `日本各地有著許多內行人才知道的隱藏版在地美酒，以及一般通路非常少見的稀有在地酒款。完美行購物與東急百貨合作，提供來自日本各地、兼具傳統與創新的酒廠所釀造的高品質日本酒。`,
        otherRecommendedSake: `其他\n精選\n日本酒`,
        recommendedWayToDrink: `建議飲用方式`,
        title: `高品質日本酒`,
        typeOfSake: `日本酒的種類`,
        dassai: {
          alcoholContent: `15`,
          brandName: `DASSAI（獺祭）`,
          brewery: `旭酒造株式會社`,
          breweryDesc: `一心追求「口感佳、爽口」的清酒，而非以大眾營銷概念釀造「好喝、好賣」的清酒。致力成為可讓人們享受美好清酒生活的釀酒廠。`,
          breweryDescTitle: `不為賣醉，不求銷量，\n追求可以細細品味的美酒`,
          breweryUrl: `https://www.asahishuzo.ne.jp/about/`,
          breweryUrlTitle: `引用出處　旭酒造株式會社官網`,
          characteristic: `使用研磨僅存至 23％ 的山田錦，打造最頂級的純米大吟釀。`,
          ingredients: `山田錦100%、米麴`,
          netContent: `720mL`,
          polishingRatio: `23`,
          price: `5700`,
          productDesc: `獺祭的旗艦商品，有著令人陶醉的芬芳和似蜂蜜的甜味，酒入喉下，口中縈繞清爽餘韻。`,
          productName: `獺祭 純米大吟釀 二割三分 \n木盒裝 720mL`,
          productionArea: `山口縣`,
          recommendedWayToDrink: `冷酒・常溫`,
          storageMethod: `溫差變化小的陰涼處\n如需長期保存，則建議冷藏`,
          typeOfSake: `純米大吟釀`
        },
        hakkaisan: {
          alcoholContent: `17`,
          brandName: `HAKKAISAN（八海山）`,
          brewery: `HAKKAISAN BREWERY（八海釀造）`,
          breweryDesc: `創立於大正11年，位於日本屈指可數的豪雪地帶「新潟魚沼地區」。\n使用孕育自靈峰八海山的超軟水「雷電神之清水」作為釀造用水，持續打造「清爽不膩口，能與料理一同促進餐桌互動的佐餐酒」。`,
          breweryDescTitle: `致力打造不影響料理風味、百喝不膩的日本酒`,
          breweryUrl: `https://ec-hakkaisan.com/pages/about`,
          breweryUrlTitle: `引用出處　八海山官網`,
          characteristic: `清爽的淡麗風味，口感層次豐富。\n出自浩和酒廠釀造的純米大吟釀。`,
          ingredients: `米（兵庫縣產 山田錦）、米麴`,
          netContent: `720mL`,
          polishingRatio: `45`,
          price: `6000`,
          productDesc: `由釀酒師傾注技術與熱情釀造而成，堅持品質且不容一絲妥協。清爽的淡麗風味，口感層次豐富。八海山作為能襯托出料理美味的「日本的日本酒」，致力打造能夠替日本與全世界的餐桌增色的酒款。`,
          productName: `八海山浩和藏純米大吟釀720mL`,
          productionArea: `新潟縣`,
          recommendedWayToDrink: `冷酒、常溫`,
          storageMethod: `沒有溫差的陰涼處\n如需長期保存，建議冷藏`,
          typeOfSake: `純米大吟釀`
        },
        imayoTsukasa: {
          alcoholContent: `17`,
          brandName: `Imayo Tsukasa（今代司）`,
          brewery: `Imayo Tsukasa（今代司酒造）`,
          breweryDesc: `今代司酒造於1767年，由初代但馬屋十左衛門創立，最初經營酒類批發及旅館、餐飲事業。\n自江戶時代末期至明治時代初期，新潟曾是北前船（往來於日本海地區的貿易商船）頻繁停靠的地區，因此而熱鬧繁榮，據說當時這裡的人口甚至比江戶還多。今代司也多虧於此，發展至今。`,
          breweryDescTitle: `將日本酒發揚光大而廣受愛戴的酒廠`,
          breweryUrl: `https://www.imayotsukasa.com/pages/aboutus`,
          breweryUrlTitle: `引用出處　今代司酒造株式會社官網`,
          characteristic: `完美結合日本兩大魅力元素——錦鯉與日本酒。\n榮獲多項設計大獎，是非常適合送禮的日本酒。`,
          ingredients: `米（日本產）、米麴（日本產米）`,
          netContent: `720mL`,
          polishingRatio: `0`,
          price: `5600`,
          productDesc: `「錦鯉」是一款如同錦鯉般華麗，能在清爽口感中品嚐到濃醇風味的日本酒。\n在現代，越來越多人只憑藉腦海中的數據來挑選酒款，\n為打破現況，錦鯉選擇不公開規格。\n希望消費者不再依靠腦中的資訊來評估味道與香氣，而是能夠實際以自己的眼、鼻、口，單純地享受這款新型日本酒。`,
          productName: `今代司「錦鯉」盒裝 720mL`,
          productionArea: `新潟縣`,
          recommendedWayToDrink: `冷酒`,
          storageMethod: `沒有溫差的陰涼處\n如需長期保存，建議冷藏`,
          typeOfSake: `不公開`
        },
        mizubasho: {
          alcoholContent: `13`,
          brandName: `MIZUBASHO（水芭蕉）`,
          brewery: `Nagai Sake（永井酒造）`,
          breweryDesc: `創立於明治19年。將日本古人們珍視的大自然與米食文化釀造出的日本酒，化作全新姿態挑戰世界。`,
          breweryDescTitle: `開創日本酒新世界的酒廠`,
          breweryUrl: `https://nagai-sake.co.jp/`,
          breweryUrlTitle: `引用出處　永井酒造株式會社官網`,
          characteristic: `構思10年，經歷數百次的反覆試驗，終於成功誕生。使用與香檳相同的製法釀造而成的氣泡清酒。`,
          ingredients: `米（日本產）、米麴（日本產米）`,
          netContent: `720mL`,
          polishingRatio: `0`,
          price: `5255`,
          productDesc: `有著如香檳般的細膩氣泡與華麗優雅的風味。在傳統的日本酒製法中，加入瓶內二次發酵工法，打造出正統的氣泡清酒，是令世界頂級主廚們也驚嘆為「從未感受過的口感」的極品。可感受櫻桃和荔枝的果香，品嚐絲滑氣泡如妖精般將料理包覆的獨特口感。`,
          productName: `MIZUBASHO PURE 720mL`,
          productionArea: `群馬縣`,
          recommendedWayToDrink: `冷酒`,
          storageMethod: `沒有溫差的陰涼處\n如需長期保存，建議冷藏`,
          typeOfSake: `氣泡清酒`
        },
        otherRecommendation: {
          moreRecommendedSake: `查看更多精選日本酒`
        },
        sakeIntro: {
          classBasics: `與普通酒相比，特定名稱酒對原料更為講究，並依據以下三個因素劃分等級：①米的精米步合（米粒的研磨比例）②是否使用吟釀製法③是否含有釀造用酒精。`,
          daiginjo: `大吟釀酒`,
          forBeginner: `不少人剛接觸日本酒時，會覺得「不習慣日本酒獨特的風味」。因此建議日本酒的新手，可以從精米步合度較低的酒款開始入門。`,
          futsushu: `普通酒`,
          ginjo: `吟釀酒`,
          honjozo: `本釀造酒`,
          junmaiDaiginjo: `純米大吟釀酒`,
          junmaiGinjo: `純米吟釀酒`,
          junmaishu: `純米酒`,
          polishing: `一般而言，精米步合度較低（酒米被磨得較細）的日本酒，雜質較少且口感清爽，多為香氣濃郁的上乘佳品。透過大量磨除米粒的外層，可以去除造成雜質的蛋白質及脂質等成分，使風味更加純淨。`,
          polishingRatioAnnotation: `＊精米步合指的是「以百分比表示經過精米程序（磨去玄米表層）的白米佔原本玄米的比重多寡」`,
          title: `關於\n日本酒的種類`,
          jozo: {
            ingredients: `米、水、米麴、釀造用酒精`
          },
          junmai: {
            ingredients: `米、水、米麴`
          }
        },
        shochikubai: {
          alcoholContent: `15`,
          brandName: `Sho Chiku Bai（松竹梅）`,
          brewery: `TAKARA SHUZO（寶酒造）`,
          breweryDesc: `寶酒造珍視大自然的恩賜，感謝並視富饒大地、溫暖陽光與滋潤雨水孕育的田地為無可取代的寶物。堅持品質，精心打造每一款商品。`,
          breweryDescTitle: `京都伏見　老字號酒廠`,
          breweryUrl: `https://www.takarashuzo.co.jp/takarahatakara/`,
          breweryUrlTitle: `引用出處　寶酒造官網`,
          characteristic: `來自老字號酒廠，展現「松竹梅」吉祥寓意的品牌。`,
          ingredients: `米（日本產）、米麴（日本產米）`,
          netContent: `1800mL`,
          polishingRatio: `0`,
          price: `5317`,
          productDesc: `松竹梅 本釀造酒裝於用作慶祝場合的傳統酒樽——角樽，口感滑順且輕爽。`,
          productName: `松竹梅 「祝樽」1.8L`,
          productionArea: `京都府`,
          recommendedWayToDrink: `溫燗（加熱至40℃）、熱燗（加熱至50）`,
          storageMethod: `沒有溫差的陰涼處\n如需長期保存，建議冷藏`,
          typeOfSake: `本釀造酒`
        }
      }
    }
  },
  question: {
    answerCount: (count: number) => `回答（${count}）`,
    answerReceived: `已收到您的回答。`,
    answerUsefulThings: `給予真心且有幫助的回答吧`,
    askEveryone: `詢問看看大家`,
    assistOthers: `請協助其他用戶,回答提問吧！`,
    completed: `完成`,
    mayBeDeleted: `※不適當的問題與回答可能由完美行免稅購物的營運方進行刪除，敬請見諒。`,
    notifiedViaEmail: `待問題收到回答時，將以電子郵件通知您。`,
    post: `發表`,
    postDetailedQuestion: `問題的內容越詳細，越能得到準確的回答。`,
    postQuestion: `提出問題`,
    questionsMayBeAnsweredByWAmazing: `部分問題亦有可能由完美行的工作人員負責回答。`,
    received: `已收到您提出的問題。`,
    responseWillBeNotified: `提問者將會收到您的回答通知。`,
    thankYouForAnswer: `感謝您提供有幫助的資訊！`
  },
  questionnaire: {
    aboutTheSurvey: `關於問卷調查`,
    afterYouPicked: (answer: string, coupon: string) =>
      `※只需在取貨後<span class=${answer}>填寫問卷</span>，即可獲得價值<span class=${coupon}>1000日圓的優惠券</span>。`,
    answer: `回答問卷`,
    answerAfterPaid: `亦可在支付餘額後，透過電子郵件中的連結回答問卷`,
    answerFromOrder: `透過訂單詳細頁面中的連結回答問卷`,
    coupon: (className?: string) => `<span class=${className}>1000日圓</span>優惠券`,
    fiveSecond: `只需5秒`,
    get: `獲得`,
    pickUpCompleted: `取貨完成後`,
    popup: (url: string, className: string) =>
      `<a href=${url} class=${className} target='_blank'>請協助填寫購物問卷</a>\n感謝您的配合！`,
    survey: `回答問卷`
  },
  questionnaireModal: {
    fiveSecond: `只需花5秒的簡單問卷`,
    getCoupon: `立即獲得1000日圓優惠券`,
    todayNotShow: `今天不再顯示`
  },
  ranking: {
    description: `日本商品人氣排行。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
    popular: `人氣排行`,
    title: `排行榜`,
    titleName: `排行`,
    meta: {
      title: `日本商品人氣排行`
    }
  },
  receive: {
    vjwRegistrationInfo: `<div class="text-sm mt-2.5">如欲在指定設施領取免稅商品，<span class="text-primary">必須在入境日本後註冊VJW（Visit Japan Web）</span></div>`,
    detail: {
      address: `地址`,
      counterDescription: `於日本全國的指定飯店面對面辦理手續後，即可領取商品`,
      lockerDescription: `可於設置在日本全國機場、車站、巴士轉運站等地的無人置物櫃，輕鬆領取商品`,
      map: `地圖`,
      notRequired: `非必須`,
      pickupAvailableTime: `可取貨時間`,
      pickupLocationDetail: `取貨地點詳情`,
      pickupLocationInfo: `取貨地點資訊`,
      receiveAtCounter: `面交取貨`,
      receiveAtLocker: `於置物櫃取貨`,
      required: (url: string) =>
        `必須（<a class="underline" href=${url} target="_blank" rel="noopener noreferrer">查看註冊方式</a>）`,
      view: `查看詳情`,
      viewOnMapApp: `使用地圖App查看`,
      vjwRegistration: `註冊VJW`,
      vjwRequiredNote: `※必須註冊VJW`
    },
    list: {
      pickupLocation: `取貨地點`,
      popularRegions: `熱門地區`,
      selectPickupLocation: `選擇取貨地點`
    },
    navigation: {
      backToPickupList: `返回取貨地點一覽表`,
      next: `下一步`,
      select: `選擇`
    },
    vjw: {
      counterInfo: (url: string) =>
        `・若要透過面對面領取辦理免稅手續，<span class="text-primary font-medium">入境日本後<a href=${url} target="_blank" rel="noopener noreferrer" class="underline">必須註冊 VJW（Visit Japan Web）</a></span>`,
      pleaseCheck: `請務必確認。`,
      registrationRequired: `■請註冊Visit Japan Web`
    }
  },
  recommended: {
    description: `完美行購物精選人氣商品。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
    mustBuyPopularJapaneseGoods: `必買日本人氣商品`,
    popularJapaneseCosmetics: `日本人氣護膚、化妝品`,
    popularJapaneseSnacks: `日本人氣零食、點心`,
    popularProducts: `推薦的熱門商品`,
    title: `精選日本人氣免稅商品`,
    viewMorePopularCosmetics: `查看更多人氣護膚品、化妝品`,
    viewMorePopularSnacks: `查看更多人氣零食、點心`,
    cosmetics: {
      description: `完美行購物（WAmazing Shop）免稅店集結了日本各大熱門美妝保養品牌，不論專櫃或開架商品皆有，可在網站上一次買齊，最適合不想花時間挑選伴手禮的旅客！可在指定機場或地點輕鬆領取商品，不必在旅途中提著大包小包，讓日本旅遊更加輕鬆自在。`
    }
  },
  recommendedArticles: {
    title: `推薦相關文章`
  },
  referral: {
    label: `推薦朋友活動`,
    pageDescription: `不需要花時間排隊！出發去日本旅行前下單即可購買到NewYork Perfect Cheese等日本超人氣商品！回國前在機場輕鬆領取商品！`,
    pageTitle: `將完美行購物介紹給朋友吧！收到介紹的朋友可獲得1,500日圓優惠券！`,
    startShopping: `開始愉快的購物體驗`
  },
  registerCampaign: {
    campaignInProgress: `活動實施中`,
    entryAndRegister: `需點此註冊新會員`,
    fiveHundredOff: (border: string, thousand: string, yen: string, off: string) =>
      `<span class=${off}>折抵</span><span class=${border}><span class=${thousand}>500</span><span class=${yen}>日圓</span></span>`,
    fiveHundredOffForBanner: (discount: string, coupon: string) =>
      `<span class=${discount}>500日圓</span><span class=${coupon}>優惠券</span>`,
    getCouponByEntryAndRegistration: `只需點此註冊新會員\n即可獲得優惠券！`,
    signUpAndGetCoupon: (className: string) => `現在註冊即可<span class=${className}>獲得1000日圓優惠券！</span>`
  },
  reviewSubmit: {
    button: `發表評價`,
    howLike: `這件商品如何？`,
    optional: `任意`,
    pleaseLogin: `輸入評論前，請先登入帳號。`,
    required: `必須`,
    thanksForReview: `感謝您的評價`,
    guide: {
      agree: (button: string) => `同意發表評價時的相關${button}`,
      button: `注意事項`,
      content: `・使用發表評價功能時，請先充分理解以下相關宗旨後再發表。\n・此平台是讓評價者針對該項商品，進行主觀評價、評分與發表評論。\n・此平台將根據評價者的經驗，收集評價資訊。\n・請盡量避免使用多餘文字、空白、平假名、表情符號及過多的換行。\n・評價不得包含以下內容，如有違反規定等情形，本公司有權刪除、編輯該項評價，或採取其他必要措施。\n　・侵犯或可能侵犯本公司、服務供應商或第三方著作權、名譽、隱私、肖像權及其他權利。\n的內容\n　・歧視、誹謗或詆毀本公司、服務供應商或第三方，以及詆毀名譽或信用的內容。\n　・涉及或鼓勵犯罪行為的內容。\n　・違反法律及善良風俗的內容。\n　・含有營利宣傳目的的內容。\n　・含有特定政治或宗教主張的內容。\n　・帶有歧視性表現的內容。\n　・含有色情猥褻、有害、低俗或令人反感的內容。\n　・其他本公司判斷為不適當內容\n・評論將被翻譯成各種語言，並發布於完美行購物網頁。是否發布由本公司自行決定。\n・本公司有權在不通知評價者的情況下，自由轉載、引用、公開、提供、出版、發布或以其他方式無償使用該則評論。評價者同意不對本公司及本公司指定者行使與評論內容有關的著作人格權。\n・本公司有權在不通知評價者的情況下，刪除或隱藏評論內容。且本公司無義務說明刪除或隱藏的原因。\n・評價者須對評論內容全權負責，本公司針對評論內容的準確性、可靠性、合法性、完整性、有效性等事項概不承擔任何責任。\n・關於發表評論的諮詢、投訴、賠償等糾紛，將由評價者自行負責與承擔，本公司概不負責。\n・關於本注意事項中未規定的事項，將遵照完美行的使用條款。關於個人資訊的使用，將遵照隱私政策。`,
      title: `注意事項`
    },
    label: {
      comment: `評論`,
      nickname: `暱稱`,
      title: `標題`
    },
    placeholder: {
      comment: `例：商品的味道、使用方便性`,
      name: `請輸入要顯示的名稱`,
      title: `請輸入標題`
    }
  },
  reviewSummary: {
    anonymous: `匿名`,
    count: (count: number) => `${count}件`,
    productName: (productName: string) => `針對${productName}的評價`,
    reviewCount: (count: number) => `${count}件評價`,
    shareReview: `與他人分享此商品資訊`,
    showOriginal: `顯示原文`,
    showTranslated: `顯示翻譯`,
    title: `評價`,
    userName: (userName: string) => `${userName}先生／小姐`,
    age: {
      fifty: `50～59歲`,
      forty: `40～49歲`,
      sixty: `60歲以上`,
      ten: `19歲以下`,
      thirty: `30～39歲`,
      title: `年齡`,
      twenty: `20～29歲`
    },
    gender: {
      female: `女性`,
      male: `男性`,
      other: `不作回答`,
      title: `性別`
    }
  },
  sakeNotice: {
    text1: `年齢確認`
  },
  search: {
    brandOrProductOrProduct: `品牌，商品，型號等`,
    enterKeywordsAlert: `請輸入您要搜尋的商品名稱等關鍵字`,
    history: `搜尋歷史`,
    keyword: `關鍵字`,
    noResultFor: (keyword: string) =>
      `無法找到符合「${keyword}」的相關結果。\n若輸入內容無誤仍無法找到相關結果，請嘗試輸入其它關鍵字。\n\n`,
    popularKeywords: `熱門關鍵字`,
    recommendedKeywords: `推薦關鍵字`,
    search: `搜尋`,
    searchItems: `搜尋商品`,
    searchResultFor: (keyword: string) => `「${keyword}」的搜尋結果`,
    searchingFor: (keyword: string) => `正在搜尋「${keyword}」……`,
    meta: {
      description: `搜尋結果。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
      title: `搜尋結果`
    }
  },
  service: {
    useFreeECshopTitle: `WAmazing免稅EC服務使用規則`
  },
  shops: {
    commonMapDescription: (className: string) =>
      `* 訂單可在收貨日期前<span class=${className}>最多3個月下訂單</span>。\n* <span class=${className}>可以在前往日本之前購買。</span>\n* 顯示時間為日本時間。`,
    list: `取貨地點列表`,
    mapTitle: `取貨地點說明`,
    pickupAvailableDates: `可取貨日期`,
    placeholder: `請選擇取貨櫃台`,
    centrair_shop: {
      listPickupLocation: `中部國際機場-交通廣場2樓`,
      lockersLocation: `中部國際機場的取貨地圖`,
      routeInformationByBusTaxi: `路線指南（搭乘巴士、計程車）`,
      routeInformationByTrain: `路線指南（搭乘電車）`,
      route: {
        busTaxi: {
          step1: `①下車後請先前往第1航廈的2樓，並朝著交通廣場的方向前進。`,
          step2: `②進入交通廣場後，請繼續直走。`,
          step3: `③沿路直走到最裡面。`,
          step4: `④完美行的取貨置物櫃就設在最裡面的隔間內。`,
          step5: `⑤完美行的取貨置物櫃就在前方。一起體驗輕鬆又方便的免稅購物服務吧！`
        },
        train: {
          step1: `①下車並出檢票口後，請馬上左轉。`,
          step2: `②沿路直走。`,
          step3: `③完美行的取貨置物櫃就設在最裡面的隔間內。`,
          step4: `④完美行的取貨置物櫃就在前方。一起體驗輕鬆愉快的免稅購物服務吧！`
        }
      }
    },
    hakata_station_shop: {
      listPickupLocation: `JR博多站取貨導覽圖`,
      lockersLocation: `2樓的Hikari 廣場內`,
      routeInformationByBulletTrain: `路線指南（於新幹線博多站下車）`,
      routeInformationByCar: `路線指南（開車前往）`,
      routeInformationByJR: `路線指南（於JR博多站下車）`,
      route: {
        finish: (number: string) => `${number}即可看到完美行免稅置物櫃。\n請體驗愉快方便的免稅購物服務吧！`,
        bulletTrain: {
          step1: `①出檢票口後，請往正前方咖啡廳的左側前進。`,
          step2: `②完美行的取貨置物櫃就在左邊。`
        },
        car: {
          step1: `①從入口進站後請直接往右走。`,
          step2: `②請搭乘右側的手扶梯上2樓。`,
          step3: `③到了2樓後，請往右前方走。`,
          step4: `④完美行的取貨置物櫃就在左邊。`
        },
        jr: {
          step1: `①出檢票口後往售票處的右方走。`,
          step2: `②請繼續直走。`,
          step3: `③請搭乘左側的手扶梯上2樓。`,
          step4: `④到了2樓後，請往右前方走。`,
          step5: `⑤完美行的取貨置物櫃就在左邊。`
        }
      }
    },
    haneda_shop: {
      listPickupLocation: `羽田機場第3航廈的取貨地圖`,
      lockersLocation: `羽田機場第3航廈站內地圖`,
      lockersLocationNotice: `※如欲搭乘電梯，請先向機場服務櫃檯詢問`,
      routeInformationByBusTaxi: `路線指南（搭乘巴士、計程車）`,
      routeInformationByKeikyu: `路線指南（搭乘京急線）`,
      routeInformationByMono: `路線指南（搭乘單軌電車）`,
      route: {
        busTaxi: {
          step1: `① 從1樓的下車處前往2樓的入境大廳，並朝著位於2樓的單軌電車站前進。`,
          step2: `②請使用單軌電車的售票機購買180日圓的車票，並進入檢票口。`,
          step3: `③完美行的取貨置物櫃就在進入檢票口的左前方。一起體驗輕鬆又方便的免稅購物服務吧！`
        },
        keikyu: {
          step1: `①下車後請朝著出口方向出檢票口。`,
          step2: `②繼續直走，並搭乘左前方的手扶梯至2樓。`,
          step3: `③下手扶梯後，沿著2樓入境大廳的指標左轉。`,
          step4: `④沿著入境大廳的指標直走，即可看到單軌電車站。請繞路並朝著單軌電車站的方向前進。`,
          step5: `⑤請使用單軌電車的售票機購買180日圓的車票，並進入檢票口。`,
          step6: `⑥完美行的取貨置物櫃就在進入檢票口的左前方。一起體驗輕鬆又方便的免稅購物服務吧！`
        },
        mono: {
          step1: `①下車後請朝著出口方向，搭乘手扶梯至2樓。`,
          step2: `②沿路左轉`,
          step3: `③完美行的取貨置物櫃就在前方。一起體驗輕鬆又方便的免稅購物服務吧！`
        }
      }
    },
    hiroshima_shop: {
      listPickupLocation: `廣島機場的取貨地圖`,
      lockersLocation: `2樓的出境大廳`,
      routeInformationByBus: `路線指南（於廣島機場站（巴士）下車）`,
      routeInformationByInternational: `路線指南（從國際線前往）`,
      route: {
        bus: {
          step1: `①從巴士下車後，搭乘手扶梯至2樓，沿著右手邊的國際出境大廳前進。`,
          step2: `②穿過中央的Soramy廣場，往右邊的「外幣兌換」店方向前進。`,
          step3: `③完美行的取貨置物櫃設在外幣兌換店的左側。`,
          step4: `④即可看到完美行免稅置物櫃。\n請體驗愉快方便的免稅購物服務吧！`
        },
        international: {
          step1: `①抵達國際線後，搭乘入境大廳的手扶梯至2樓，並左轉直行。`,
          step2: `②往右側的外幣兌換店前進，即可看到完美行的取貨置物櫃設在左側。`,
          step3: `③即可看到完美行免稅置物櫃。\n請體驗愉快方便的免稅購物服務吧！`
        }
      }
    },
    kansai_shop: {
      listPickupLocation: `JR關西機場站的站內圖`,
      lockersLocation: `關西機場置物櫃的位置圖`,
      routeInformationByJR: `路線說明（搭乘JR線）`,
      routeInformationByOthers: `路線說明（搭乘JR線以外的交通方式）`,
      route: {
        jr: {
          step1: `①下車後，由月台往上至2樓（檢票口樓層）。`,
          step2: `②抵達2樓檢票口樓層後，會看到一個大型地圖看板，接著往左前進。`,
          step3: `③往前後將會看到ATM，請繞到ATM後方。`,
          step4: `④ 繞過ATM後，即可看到完美行免稅置物櫃。體驗輕鬆愉快的免稅購物吧！`
        },
        others: {
          step1: `①抵達關西國際機場第1航廈後，請前往位於2樓的「JR關西機場站」。`,
          step1note: `*搭乘利木津巴士的旅客：請在抵達第1航廈4樓國際線出發樓層後，往下移動至2樓。\n*乘船的旅客：請在抵達關西機場高速船碼頭後，搭乘專用接駁巴士，在抵達第1航廈4樓國際線出發樓層後，往下移動至2樓。`,
          step2: `②在地下鐵售票處，前往右側藍色看板的JR售票處購買車票。`,
          step3: `③在售票機購買150日圓的車票後，進入後方的JR檢票口內。`,
          step4: `④進入檢票口會看到一個大型地圖看板，接著往左前進。`
        }
      }
    },
    mapDescription: {
      centrair_shop: (className: string) =>
        `完美行的取貨置物櫃設在<span class=${className}>中部國際機場-交通廣場2樓</span>`,
      hakata_station_shop: (className: string) =>
        `完美行的取貨櫃設在「JR博多站」<span class=${className}>2樓的Hikari廣場內</span>。`,
      haneda_shop: (className: string) =>
        `完美行的取貨置物櫃設在羽田機場第3航廈2樓入境大廳的「<span class=${className}>單軌電車檢票口內</span>」。\n\n<span class=${className}>※建議搭乘單軌電車。\n※若不搭乘單軌電車，請另行購票進入站內。</span>`,
      hiroshima_shop: (className: string) =>
        `完美行的取貨置物櫃設在「廣島國際機場」<span class=${className}>2樓的出境大廳。</span>`,
      kansai_shop: (className: string) =>
        `完美行的取貨置物櫃設置於<span class=${className}>「JR關西機場站」</span>檢票口內的2樓。\n\n<span class=${className}>※建議搭乘JR線前往機場。\n※若不搭乘JR線前往機場，請另行購買車票後，再進入檢票口。</span>`,
      naha_station_shop: (className: string) =>
        `完美行的取貨置物櫃設於「那覇機場」<span class=${className}>2樓的免費充電區</span>內。`,
      narita1_shop: (className: string) =>
        `完美行的取貨置物櫃設置於<span class=${className}>成田機場第1航廈JR成田機場站</span>。\n※建議搭乘<span class=${className}>JR東日本</span>鐵道，於<span class=${className}>成田機場站</span>下車。\n`,
      narita2_shop: (className: string) =>
        `完美行的取貨置物櫃設置於<span class=${className}>成田機場第2航廈JR機場第2航廈站</span>。\n※建議搭乘<span class=${className}>JR東日本</span>鐵道，於<span class=${className}>機場第2航廈站</span>下車。\n`,
      new_chitose_shop: (className: string) =>
        `完美行的取貨置物櫃設置於<span class=${className}>新千歲機場-國際線航廈1樓</span>。\n\n※從JR車站到置物櫃約需<span class=${className}>10分鐘</span>。請預留足夠時間前往取貨。`,
      sendai_shop: (className: string) =>
        `完美行的取貨置物櫃設在『仙台國際機場』<span class=${className}>1樓的入境大廳</span>。`,
      tenjin_shop: (className: string) =>
        `完美行的取貨置物櫃設置於<span class=${className}>天神巴士轉運站3樓下車處</span>。\n\n\n※推薦搭乘<span class=${className}>西日本鐵道（西鐵）</span>於<span class=${className}>西鐵天神站</span>下車。`
    },
    messages: {
      earliestPickupDate: `最快可取貨日期`,
      minimumPickUpTime: (year: string, month: string, day: string, hour: string, minute: string, className: string) =>
        `最快可取貨時間：<span class=${className}>${year}年${month}月${day}日 ${hour}:${minute}起</span>`,
      minimumPickUpTimeSp: (
        year: string,
        month: string,
        day: string,
        hour: string,
        minute: string,
        className: string
      ) => `<span class=${className}>取貨時間</span><span>${year}年${month}月${day}日 ${hour}:${minute}起</span>`
    },
    naha_shop: {
      listPickupLocation: `那霸機場的取貨地圖`,
      lockersLocation: `那霸機場2樓`,
      routeInformationByDomestic: `路線指南（從國內線前往）`,
      routeInformationByInternational: `路線指南（從國際線前往）`,
      route: {
        domestic: {
          step1: `①請往2樓的國際線登機門D的方向前進。`,
          step2: `②在登機門D的前方左轉，朝洗手間的方向走。`,
          step3: `③走到底，即可看見完美行的取貨置物櫃就在左邊。`
        },
        international: {
          step1: `①請往旅客服務中心前進，搭乘右側的手扶梯上2樓。`,
          step2: `②到了2樓後，即可看見完美行的取貨置物櫃就在左邊。`
        }
      }
    },
    narita1_shop: {
      listPickupLocation: `成田機場站的取貨地圖`,
      lockersLocation: `成田機場站的導覽地圖`,
      routeInformationByJR: `路線指南（於JR東日本的成田機場站下車）`,
      routeInformationByKeisei: `路線指南（搭乘京成線）`,
      route: {
        finish: (routeNumber: string) => `${routeNumber}請體驗愉快方便的免稅購物服務吧！`,
        busTaxi: {
          step1: `①下車後請往JR檢票口方向前進。`,
          step2: `②於JR售票機購買150日圓車票，通過檢票口進站。`,
          step3: `③往等候室方向前進，完美行的取貨置物櫃就在右邊。`
        },
        jr: {
          step1: `①下車後，請搭乘手扶梯上樓。`,
          step2: `②往出口方向前進。`,
          step3: `③完美行的取貨置物櫃就在面向出口的左邊。`
        },
        keisei: {
          step1: `①下車後，請搭乘手扶梯上樓朝出口方向前進。`,
          step2: `②出站後往JR檢票口方向前進再左轉`,
          step3: `③於JR售票機購買150日圓車票，通過檢票口進站。`,
          step4: `④往等候室方向前進，完美行的取貨置物櫃就在右邊。`,
          ticket: `※車票購買方法\n注意：取完貨出檢票口時請向站務員說明「車票是用來入場的」。`
        }
      }
    },
    narita2_shop: {
      listPickupLocation: `成田機場第2航廈站的取貨地圖`,
      lockersLocation: `成田機場第2航廈站的導覽地圖`,
      routeInformationByJR: `路線指南（於JR東日本機場第2航廈站下車）`,
      routeInformationKeisei: `路線指南（搭乘京成線）`,
      route: {
        busTaxi: {
          step1: `①下車後請往JR檢票口方向前進。`,
          step2: `②前進至JR檢票口，於JR售票處向站務員購買入場車票。`,
          step3: `③進JR檢票口，完美行的取貨置物櫃就在面向洗手間的右邊。`
        },
        jr: {
          step1: `①下車後，請搭乘手扶梯上樓。`,
          step2: `②請朝檢票口對面的洗手間方向前進。`,
          step3: `③完美行的取貨置物櫃就在面向洗手間的右邊。`
        },
        keisei: {
          step1: `①下車後，請搭乘手扶梯上樓。`,
          step2: `②出檢票口後向左轉`,
          step3: `③往第2、第3航廈方向前進`,
          step4: `④前進至JR檢票口，於JR售票處向站務員購買入場車票。`,
          step5: `⑤進JR檢票口，完美行的取貨置物櫃就在面向洗手間的右邊。`,
          ticket: `※入場車票示意圖`
        }
      }
    },
    new_chitose_shop: {
      listPickupLocation: `新千歲機場的取貨地圖`,
      lockersLocation: `新千歲機場- 1樓`,
      routeInformationByBusTaxi: `路線指南（搭乘巴士、計程車）`,
      routeInformationByTrain: `路線指南（搭乘電車）`,
      route: {
        busTaxi: {
          step1: `①下車後，進入航廈，前往２樓後往「國際線」方向前進。`,
          step2: `②沿著「國際線」的指示牌走到底。`,
          step3: `③於道路盡頭左轉並繼續前進。`,
          step4: `④經過便利商店後，於道路盡頭右轉。`,
          step5: `⑤使用道路盡頭的電梯前往1樓。`,
          step6: `⑥出電梯後，向左邊前進。`,
          step7: `⑦往前走後，完美行的取貨置物櫃就在右手邊。盡情享受輕鬆愉快的免稅購物體驗吧！`
        },
        train: {
          step1: `①下車出檢票口後，使用前方的電梯前往2樓。`,
          step2: `②出電梯後，往「國際線」方向前進。`,
          step3: `③沿著「國際線」的指示牌走到底。`,
          step4: `④於道路盡頭左轉並繼續前進。`,
          step5: `⑤經過便利商店後，於道路盡頭右轉。`,
          step6: `⑥使用道路盡頭的電梯前往1樓。`,
          step7: `⑦出電梯後，向左邊前進。`,
          step8: `⑧往前走後，完美行的取貨置物櫃就在右手邊。盡情享受輕鬆愉快的免稅購物體驗吧！`
        }
      }
    },
    notice: {
      aboutOrder: `發送時間需花費3天以上，請提早購買。`
    },
    sendai_shop: {
      listPickupLocation: `仙台國際機場的取貨地圖`,
      lockersLocation: `1樓的入境大廳`,
      routeInformationByInternational: `路線指南（從國際線前往）`,
      routeInformationUseSdj: `路線指南（於仙台國際機場站下車）`,
      route: {
        international: {
          step1: `①完美行的取貨置物櫃設在國際線入境後的出口左側。`
        },
        sdjInternational: {
          step1: `①出檢票口後往右側的通道前進。`,
          step2: `②走到盡頭後依照指示牌左轉並繼續前進。`,
          step3: `③走到盡頭後向出口的右手邊前進。`,
          step4: `④搭乘右手邊的手扶梯至1樓`,
          step5: `⑤到1樓後，朝著左前方的入境大廳前進。`,
          step6: `⑥走到底後，即可看到完美行的取貨置物櫃設在左側。`
        }
      }
    },
    tableHeader: {
      receivableDate: `取貨日期`,
      shopName: `取貨地點名`
    },
    tenjin_shop: {
      listPickupLocation: `天神巴士轉運站- 3樓`,
      lockersLocation: `天神巴士轉運站的取貨地圖`,
      routeInfomation: `路線指南（西鐵天神站下車）`,
      route: {
        step1: `①下車出北側檢票口後向左轉。`,
        step2: `②沿著「高速巴士（抵達）」的指示牌，往下車處方向前進。`,
        step3: `③搭電梯前往3樓`,
        step4: `④出電梯後，沿反方向前進（途經服務中心）`,
        step5: `⑤繼續直走，盡頭即可看到完美行的取貨置物櫃`,
        step6: `⑥請體驗愉快方便的免稅購物服務吧！`
      }
    }
  },
  staticWalkthrough: {
    description: `完美行購物服務介紹。購買日本免稅伴手禮，就到完美行購物！品項豐富的日本人氣美妝和零食應有盡有。購買完成後可以在指定的機場領取商品。`,
    heading: `完美行購物服務介紹`,
    pickupsSectionHeading: `取貨地點名`,
    safeAndConveneientShoppingService: (className: string) =>
      `只需於完美行購物線上免稅店預約好商品，即可在<span class=${className}> 指定機場領取商品</span>的「安心、方便免稅購物服務」。`,
    serviceBenefitsHeading: `線上免稅購物的好處`,
    serviceBenefitsSubheading: `輕鬆解決旅行中與購物有關的煩惱，能更靈活運用有限的時間暢玩日本。`,
    title: `服務介紹`,
    aboutPurchase: {
      btn: `確認「日本免稅制度」`,
      heading: `有關免稅購物`,
      listItem1: `・一次購買5,000日圓（不含稅）以上即可免税 \n`,
      listItem2: `・免稅手續僅適用於持有短期滯留簽證者`,
      listItem3: `・每人1天可購買最多50萬日圓的免稅商品`,
      listItem4: `・請於取貨日前3天訂購。`
    },
    banner: {
      banner1: {
        text: `推薦人氣化妝品`,
        title: `可安心選購`
      },
      banner2: {
        text: `推薦人氣零食`,
        title: `必買`
      }
    },
    faqs: {
      answer1: `可以，只要是停留在日本國內的期間，均可任意選擇取貨時間。`,
      answer2: `付款方式為事前線上刷卡，目前系統支援VISA、Mastercard、JCB、美國運通卡。\n使用wechatpay的用戶，於取貨支付餘額時也須使用wechatpay。`,
      answer3: `已成立的訂單無法變更領取時間，請取消後再次重新購買。`,
      answer4: `・結帳時須確保手機連線至網路。請務必備妥網路。\n・僅限預約購買者本人辦理手續。請務必由預約購買者本人到場。\n・為完成購買手續，預約購買者本人需出示護照及護照上的入境許可貼紙，請務必攜帶至現場。\n　　　僅限含晶片的電子護照，以及有效期限內的入境許可貼紙。\n・為完成購買手續，需拍攝預約購買者本人的臉部照片，敬請理解。\n・取貨時需以信用卡結帳。請留意信用卡上限額度。`,
      btn: `確認所有流程介紹`,
      heading: `常見問題`,
      question1: `我可以在出境日以外的時間取貨嗎？`,
      question2: `如何付款？`,
      question3: `可以更改領取日期嗎？`,
      question4: `領取商品時需要準備什麼東西？`
    },
    serviceBenefits: {
      issueLink: `無法順利取貨時,請點此處`,
      card1: {
        body: (className: string) =>
          `適合因語言不通苦於<span class=${className}> 尋找店家</span>、雨天害怕<span class=${className}> 淋濕</span>、需花時間<span class=${className}>排隊 </span>等，而感到不安的旅客。`,
        footer: `線上輕鬆預購`,
        title: `尋找店家相當不容易`
      },
      card2: {
        body: (className: string) =>
          `適合因<span class=${className}>買太多不方便攜帶 </span>、<span class=${className}> 提著大包小包坐電車很麻煩</span>，<span class=${className}> 受人所託購買商品</span>，而感到麻煩的旅客。`,
        footer: `可在機場輕鬆領取商品`,
        title: `提著大包小包相當不便`
      },
      card3: {
        body: (className: string) =>
          `適合因<span class=${className}> 店家無法免稅</span>、<span class=${className}> 語言不通</span>，<span class=${className}> 店家會酌收免稅手續費</span>等，而感到麻煩的旅客。`,
        footer: `簡單核對免稅手續`,
        title: `對免稅手續感到不安`
      },
      card4: {
        body: (className: string) =>
          `適合因擔心<span class=${className}> 人群聚集</span>、想<span class=${className}>避免接觸及非必要溝通 </span>，以及想<span class=${className}> 降低感染風險</span>的旅客。`,
        footer: `不需當面取貨`,
        title: `對與人接觸仍感不安`
      },
      card5: {
        body: (className: string) =>
          `適合因跟團旅行<span class=${className}>沒有時間購物 </span>、<span class=${className}> 只能逛旅行社安排好的免稅店</span>，而感到不滿意的旅客。`,
        footer: `跟團旅行也能盡興購物`,
        title: `沒有自由時間`
      },
      card6: {
        body: (className: string) =>
          `適合擔心商品<span class=${className}>並非正品 </span>、不想因為拿假貨送禮而感到尷尬，以及想放心購物的旅客。`,
        footer: `可放心購買的正品`,
        title: `擔心買到假貨`
      },
      card7: {
        body: (className: string) =>
          `適合擔心<span class=${className}> 搞錯日期無法取貨</span>、<span class=${className}> 搞錯地點無法取貨</span>等狀況發生的旅客。`,
        footer: `令人安心的全方位協助`,
        title: `擔心各種狀況`
      }
    },
    serviceUsageFlow: {
      heading: `使用流程`,
      usageCard1: {
        body: `除了必買伴手禮之外，來自日本全國各地的限定伴手禮都能在線上輕鬆選購！`,
        title: `線上購物`
      },
      usageCard2: {
        body: `可以原價20%的價格輕鬆預訂喜愛的商品！`,
        title: `支付預約手續費`
      },
      usageCard3: {
        body: `於取貨地點支付80%的餘額，核對免稅資格後即可領取商品！`,
        title: `於取貨地點\n付款並領取商品`
      }
    }
  },
  systemMaintenance: {
    text: `系統將於9/26（四）4:30〜5:30（JST）進行維護作業，完美行購物的網頁及APP於系統維護期間暫時無法使用，敬請見諒。`
  },
  taxFreeGuide: {
    description: (className: string) =>
      `難得開心到日本旅行！除了時尚景點和歷史悠久的觀光地之外，購物也是日本旅行的一大樂趣！既然來了，當然會<span class=${className}>希望以免稅的優惠價格盡情購物！</span>\n適合抱持「能否順利溝通而感到不安」、「免稅的條件是什麼？」、「不想因出錯而留下不好的回憶」等想法的旅客！不需再一一確認<span class=${className}>日本的免稅手續</span>細節，一起開心享受不失敗的日本免稅商店購物吧！\n`,
    title: `日本免稅指南`,
    TaxExemption: {
      heading: `何謂日本的免稅制度？`,
      Item1: {
        description: `以持有效期為6個月的短期滯留簽證外國人為對象。辦理免稅手續時，須出示貼有有效的短期滯留上陸許可貼紙之護照。`,
        title: `以持有短期滯留簽證者為免稅對象`
      },
      Item2: {
        description: `單次消費滿5,000日圓以上，即可以免稅價格購物。\n若購買消耗品則以同一店鋪單日50萬日圓（不含稅）為上限。`,
        title: `消費滿5,000日圓以上即可免稅。`
      },
      Item3: {
        description: `部分適用輕減稅率的商品稅率為8%。`,
        title: `可直接免除10%消費稅。`
      }
    },
    dutyFree: {
      description: `標有Tax-free shop標誌之網路商店、藥妝店、百貨公司，以及便利商店等皆有提供免稅服務。`,
      heading: `日本有哪些店家可購買免稅商品？`,
      card1: {
        d1: `免稅手續`,
        d2: `透過網路輕鬆購物`,
        d3: `無需面對店員`,
        d4: `無需面對店員，更加安心`,
        d5: `輕便`,
        d6: `可將商品寄送至機場，減輕旅途中的負擔。`,
        description: (className: string) =>
          `擔心在語言不通的環境下<span class=${className}>尋找店家</span>，害怕<span class=${className}>下雨淋濕</span>或<span class=${className}>大排長龍</span>等問題的旅客，網路商店可說是最佳選擇！`,
        heading: `網路商店`
      },
      card2: {
        d1: `免稅手續`,
        d2: `可當場退稅`,
        d3: `無需面對店員`,
        d4: `面對面`,
        d5: `輕便`,
        d6: `需提著行李走動`,
        description: (className: string) =>
          `逛街雖然好玩，但要<span class=${className}>提著滿滿的戰利品，搭乘電車</span>繼續接下來的行程可不輕鬆。若是<span class=${className}>幫親友代買</span>，就更加<span class=${className}>麻煩</span>了。此時網路商店就是一個好選擇。`,
        heading: `藥妝店`
      },
      card3: {
        d1: `免稅手續`,
        d2: `耗費時間`,
        d3: `無需面對店員`,
        d4: `面對面`,
        d5: `輕便`,
        d6: `需提著行李走動`,
        description: (className: string) =>
          `無論是<span class=${className}>不提供免稅服務的店家</span>、<span class=${className}>語言不通的店家</span>、還是<span class=${className}>酌收免稅手續費的店家</span>，在網路商店購物皆可免去上述麻煩。`,
        heading: `百貨公司`
      }
    },
    dutyFreeFlow: {
      heading: `確認網路免稅商店的\n購物流程。`
    },
    dutyFreePrecautions: {
      heading: `與日本免稅商品相關的注意事項`,
      info: `・屬於消耗品之免稅商品不可在日本國內打開包裝使用。\n・不可在出境前將免稅商品轉讓於他人。\n・飲料、調味料、化妝品等液態免稅品，需遵守航空公司的物品攜帶規定。\n・若將免稅品寄送至海外，須向海關出示郵局發行的收據、寄件證明單。\n・免稅品必須由購買者本人攜帶出境。`
    },
    faqs: {
      answer1: `DUTY FREE：基於關稅法的免稅制度，消費稅、關稅、酒稅，以及菸稅皆為免稅對象。適用店家大多位於國際機場的出境處。\nTAX FREE：基於消費稅法的免稅制度，以一般可購買商品及消耗品為免稅對象。適用店家主要為街上的購物區。`,
      answer2: `依據新制度，辦理免稅時須出示「護照」與「所購入的免稅商品」。`,
      answer3: `不行。免稅手續必須於購買當天辦理。`,
      answer4: `因自動通關入境者的護照上並未蓋有入境印章，故有可能無法辦理免稅手續，建議事先向入國管理局索取入境印章。`,
      answer5: `可攜入機內之液體上限為100ml，超過將無法受理。\n但若符合以下條件則允許攜帶上機。\n・將液體放入行李箱託運\n・出境後購買的液態免稅品可攜上飛機（※僅限直飛航班）`,
      answer6: `不行，免稅手續僅限購買者本人辦理。`,
      answer7: `不行，將免稅商品攜帶出境為購買者之義務。`,
      heading: `免稅手續的常見問題`,
      question1: `「DUTY FREE」與「TAX FREE」有何不同？`,
      question2: `辦理免稅手續時需出示什麼？`,
      question3: `是否可在購入商品的隔天才辦理免稅手續？`,
      question4: `使用機場自動通關入境者可否辦理免稅手續？`,
      question5: `液態免稅品可否攜入機內？`,
      question6: `免稅手續可否交由他人代辦？`,
      question7: `免稅商品是否可委託他人攜帶出境？`
    },
    meta: {
      description: `有關日本免税購物。利用完美行購物，讓來日本旅行時能以更輕鬆的方式、更划算的價格購買日本伴手禮。`,
      title: `日本免稅購物指南`
    },
    products: {
      description: `基本上標有Tax-free shop標誌之網路商店、藥妝店、百貨公司，以及便利商店等皆有提供免稅服務。`,
      heading: `日本有哪些商品可以免稅？`,
      card1: {
        info: `※每位符合免稅資格者，單日於同一店家購物達5千日圓以上即可免稅。\n※可於日本國內使用，但須在入境日本後的6個月內攜帶出境。`,
        item1: `飾品`,
        item2: `服飾`,
        item3: `包包`,
        item4: `鞋子`,
        item5: `家電商品`,
        item6: `相機`,
        item7: `鐘錶`,
        title: `在日本可免稅的一般商品`
      },
      card2: {
        info: `※每一位符合免稅資格者，單日於同一店家購物達5千日圓以上、50萬日圓以下。\n※不可在日本國內使用，須在入境日本後的6個月內攜帶出境。`,
        item1: `化妝品`,
        item2: `食品`,
        item3: `酒類`,
        item4: `香菸`,
        item5: `保健食品`,
        item6: `醫藥品`,
        title: `在日本可免稅的消耗性商品`
      }
    }
  },
  taxFreeShop: {
    article1: `第1條（條款的適用）`,
    article10: `第10條（本網站及本服務的暫時停止）`,
    article10Sentence1: `在下述各項的情況下，本公司可以不事先通知會員而暫時停止運營本網站及本免稅EC服務：`,
    article10Sentence2: `（1）進行本網站的維護或設計變更時；`,
    article10Sentence3: `（2）發生或有可能發生自然災害或其他緊急情況、導致無法運營本網站及本免稅EC服務時；`,
    article10Sentence4: `（3）其他本公司判斷因不得已的事由需要暫時停止運營本網站及本免稅EC服務時。`,
    article11: `第11條（本公司的免責）`,
    article11Sentence1: `1. 因自然災害、線路擁堵、機器故障或維護導致的停機、商品供應商的信息丟失、或因第三方導致的信息篡改或洩露等原因產生的損害，除損害是因歸責於本公司的事由造成的，本公司概不負責。`,
    article11Sentence2: `2. 即使在本公司就會員對本免稅EC服務的使用相關負責的情況下，除本公司的故意或重大過失外，本公司的責任僅限於直接且普通的損害。`,
    article12: `第12條（準據法、語言、管轄法院）`,
    article12Sentence1: `1. 本免稅EC服務使用條款以日本法為準據法，並按日本法予以解釋。`,
    article12Sentence2: `2. 本免稅EC服務使用條款以日語為正文，並按日語予以解釋和簽訂。本免稅EC服務使用條款除日語之外的其他語言的翻譯版本僅作參考之用，不對以日語對本免稅EC服務使用條款進行的解釋作任何變更。`,
    article12Sentence3: `3. 就本免稅EC服務使用條款產生的糾紛的第一審專屬管轄法院為東京地方法院。`,
    article1Sentence1: `1. 本免稅EC服務使用條款適用於通過WAmazing株式會社（以下簡稱“本公司“）管理的網站（以下統稱“本網站“）進行會員註冊的會員使用本免稅EC服務（參照下條的定義）時進行的一切行為，會員應在同意本免稅EC服務使用條款後使用本免稅EC服務。`,
    article1Sentence2: `2. 如本公司於本免稅EC服務中對各注意事項等（以下簡稱“各注意事項等“）進行了提示的，各注意事項等分別構成本免稅EC服務使用條款的一部分。`,
    article1Sentence3: `3. 本公司可無需事先通知會員而隨時修改本免稅EC服務使用條款，本公司修改後的本免稅EC服務使用條款於刊載在本公司指定網站之時（如對本公司修改後的本免稅EC服務使用條款的生效日有另行設定的，以該另行設定之日為準）發生效力。會員在修改後使用本免稅EC服務的，視為同意修改後的本免稅EC服務使用條款。`,
    article2: `第2條（本免稅EC服務的定義及買賣預約合同的成立）`,
    article2Sentence1: `1. 本免稅EC服務是指，會員自發地通過本網站使用能達成以下目的的服務：`,
    article2Sentence2: `① 購買及預約購買本公司在本網站上刊載的商品`,
    article2Sentence3: `2. 會員可在本網站上通過以下方式進行商品購買的預約：`,
    article2Sentence4: `① 會員完成在本網站上輸入本公司指定的必要信息（包括客戶信息、訂單信息、支付信息等）、在本網站上申請商品的預約購買、並支付第4條規定的預約手續費的同時，預約完成。此外，在本網站上完成預約的時刻，本公司和會員之間就該商品的買賣預約合同（以下簡稱“買賣預約合同“）同時成立。`,
    article2Sentence5: `3. 可預約期間為本網站上公示的期間。`,
    article2Sentence6: `4. 為證明買賣預約合同的成立，本公司將在本網站內的會員頁面發送「買賣預約合同成立畫面」。`,
    article2Sentence7: `5. 本公司和會員之間根據本條規定成立買賣預約合同的，視為會員已接受自行承擔第5條規定的取消費用等的義務。`,
    article3: `第3條（商品價格的變更等）`,
    article3Sentence1: `1. 會員知曉，本網站上刊載的關於商品價格等的信息可能會與其他媒體提供的信息有所差異。`,
    article3Sentence2: `2. 會員知曉，商品價格等可能會不經預告地進行變更。變更後的商品價格等只對於變更後申請預約的會員適用，在變更前已進行了預約申請的會員適用變更前的商品價格等。`,
    article4: `第4條（商品預約手續費的支付）`,
    article4Sentence1: `會員應在進行商品的購買預約時向本公司支付相當於該商品價格的20%作為預約手續費（預約手續費中含消費稅）。但，商品頁面等中另有說明的，應從其說明。此外，會員取消或購入已預約商品之前均無權要求退還預約手續費。`,
    article5: `第5條（預約取消的成立和取消費用的產生）`,
    article5Sentence1: `1. 會員可在購買預約時指定的收貨日當天之前，根據買賣預約合同取消全部預約商品的購買預約。但，此種情況下，會員只能一次性取消全部商品的預約、不能僅取消部分商品的預約。`,
    article5Sentence2: `2. 會員在商品向指定收貨地點發貨前取消商品的購買預約的，就該商品的取消不產生取消費用。此種情況下，本公司根據上條進行預約手續費的退款處理。`,
    article5Sentence3: `3. 會員在商品向指定收貨地點發貨後取消商品的購買預約，將產生預約手續費全額的取消費用。但，商品頁面等中另有說明的，應從其說明。`,
    article5Sentence4: `4. 會員在購買預約時指定的收貨日當天之前沒有對已預約商品進行購買或取消的意思表示的，視為會員取消該商品的預約，併產生預約手續費全額的取消費用。但，商品頁面等中另有說明的，應從其說明。`,
    article5Sentence5: `5. 即使會員不希望取消預約，但本公司根據會員就本免稅EC服務使用相關的預約內容判斷其違反了法律法規等規定或可合理地判斷為不適當的，本公司有權取消該預約。此種情況下的取消費用及退款處理根據上述各款執行。`,
    article6: `第6條（買賣合同的成立、商品價格的確定及商品的交付）`,
    article6Sentence1: `1. 選擇在本公司櫃檯收貨的\n會員應在購買預約時指定的收貨日、於購買預約時指定的收貨地點的本公司櫃檯的營業時間內到店、對本公司進行購買已預約商品的意思表示，並完成本公司指定的手續時，會員與本公司之間就該商品的買賣合同成立，本公司對會員交付該商品。`,
    article6Sentence2: `2. 選擇在儲物櫃收貨的\n會員應在購買預約時指定的收貨日、於購買預約時指定的收貨地點所在的儲物櫃對本公司表明進行購買已預約商品的意思，並根據本公司指定的手續操作完成時，會員與本公司之間就該商品的買賣合同成立，本公司對會員交付該商品。`,
    article6Sentence3: `3. 本公司應將第4條的預約手續費抵作買賣合同成立後商品的價款。`,
    article6Sentence4: `4. 會員在購買預約時指定的收貨日當天之前沒有對已預約商品進行購買或取消的意思表示的，本公司將其視為會員取消該商品的預約，此種情況的取消費用根據上條規定執行。`,
    article7: `第7條（會員的遵守事項）`,
    article7Sentence1: `1. 未經本公司同意，會員不得將通過使用本網站獲得的信息以個人使用以外的目的進行複製、傳播等，也不得以任何形式提供給第三方使用。`,
    article7Sentence10: `（8）拒不支付本公司請求的預約手續費、取消費用或商品價款的行為（無論理由為何）；`,
    article7Sentence11: `（9）對本公司或第三方的暴力或騷擾行為；`,
    article7Sentence12: `（10）被認定為以向他人轉賣或以商用為目的的預約行為；`,
    article7Sentence13: `（11）其他任何違反或可能違反法律法規的行為。`,
    article7Sentence14: `3. 如本公司或第三方因會員做出的前款各項的任一行為遭受損害的，會員應承擔全部法律責任，不得對本公司及第三者造成任何損害。`,
    article7Sentence15: `4. 如會員不滿足法律法規等規定的就商品購買免征消費稅的條件，但仍向本公司進行了購買已預約商品的意思表示的，除了該商品的價款外，會員應另行向本公司支付相當於該商品的消費稅金額。`,
    article7Sentence16: `5. 本公司根據第8條第1款取消了本免稅EC服務使用相關的預約的，會員應根據第5條的規定支付取消費用。`,
    article7Sentence17: `6. 如會員為未成年人，應取得法定代理人的同意後進行預約。如會員謊稱其得到了法定代理人的同意或謊稱其為成年人，其進行的預約行為也不能被取消。`,
    article7Sentence2: `2. 在使用本免稅EC服務時，會員不得有如下行為：`,
    article7Sentence3: `（1）冒充第三方發送或填寫信息的行為；`,
    article7Sentence4: `（2）以本公司許可以外的方式使用本免稅EC服務的行為；`,
    article7Sentence5: `（3）發送或寫入有害計算機程序的行為，發送廣告郵件、連環信件、垃圾郵件等行為；`,
    article7Sentence6: `（4）侵害或可能侵害本公司或第三方的著作權及其他知識產權的行為；`,
    article7Sentence7: `（5）對本公司及第三方進行誹謗、中傷或損害名譽的行為；`,
    article7Sentence8: `（6）向他人公開違反公序良俗的信息、文件及圖像等的行為；`,
    article7Sentence9: `（7）無論是否故意，提供虛假或不完整的本免稅EC服務的用戶或會員個人的姓名、住所、電話號碼、郵箱地址、信用卡號碼等信息進行註冊的行為；`,
    article8: `第8條（會員遵守事項的違反）`,
    article8Sentence1: `1. 如會員違反上條規定的遵守事項或有其他被本公司判斷為對本免稅EC服務的運營上不利的情況的，本公司有權採取制止該行為、取消該會員與本公司的買賣預約合同或買賣合同、停止含本免稅EC服務在內的與本網站相關的一切服務的使用、剝奪其會員資格或要求賠償損失等必要的措施（包括法律措施）。`,
    article8Sentence2: `2. 如本公司推測會員違反上條規定的遵守事項或有其他被本公司判斷為對本免稅EC服務的運營上不利的情況的，可向會員確認該行為的詳細情況。`,
    article9: `第9條（著作權）`,
    article9Sentence1: `1. 未經本公司事前同意，會員不得將通過使用本網站獲得的全部內容以著作權規定的會員個人使用以外的目的進行使用。`,
    article9Sentence2: `2. 如因違反本條規定產生糾紛的，會員應自行承擔費用和責任解決該糾紛，且不得給本公司及第三方造成任何損害。`,
    mainTitle: `WAmazing免稅EC服務使用條款【用於購買商品時_普通稅收方案】`
  },
  vendor: {
    sugi: `SUGI藥局 川口戶塚店`,
    tokyu: `東急百貨店`,
    wamazing: `完美行購物`
  },
  wonderCompass: {
    discoverTheCharmOfJapan: (className: string) =>
      `只要參加現場的免稅商品取貨體驗，\n<span class=${className}>即可獲得日本的人氣伴手禮！</span>\n現場領取日本各地伴手禮，感受日本的魅力！`,
    justThreeMins: `只需短短3分鐘`,
    location: `WANDER COMPASS SHIBUYA位於澀谷109旁， 澀谷站A2出口的地下通道。`,
    overview: `活動詳情`,
    title: `2023年9月30日為止的現場取貨體驗活動開跑！`,
    contents: {
      address: `地址：Shibuya Station B1 floor, 2 Chome-1-1 Dōgenzaka, Shibuya-ku, Tokyo`,
      period: `期間：2023/8/1〜2023/9/30`,
      place: `地點：WANDER COMPASS SHIBUYA`,
      time: `時間：10:00〜20:00`
    }
  },
  yamazakiGift: {
    period: `於4/8（週二）～4/21（週一）期間內下單\n並\n於5/1（週四）～5/31（週六）期間內取貨`,
    promotionDetails: `使用下方指定的9折優惠券結帳並消費滿30,000日圓，就有機會獲得超人氣威士忌「山崎威士忌」！我們將從符合條件者中抽出20位幸運得主，快來試試手氣吧！`,
    conditions: {
      text1: `消費滿30,000日圓`,
      text2: `使用下方指定的9折優惠券結帳（請於購物車中選擇使用優惠券）`
    },
    entryBotton: {
      text1: `已報名`,
      text2: `請到購物車畫面「選擇優惠券」處輸入代碼`,
      text3: `優惠券的使用方法`,
      text4: `請點擊這個按鈕！`
    },
    meta: {
      title: `★消費滿30,000日圓即可參加抽獎！20位幸運兒將可獲得「山崎威士忌」★`
    },
    modal: {
      title: `感謝您的參加`
    },
    notes: {
      list1: `抽獎對象僅限使用優惠券購物者。`,
      list2: `優惠券不適用於購買醫藥品及酒類商品。`,
      list3: `如取消訂單，將無法參加抽獎。`,
      list4: `訂單一經成立，將無法更改商品內容、取貨地點及時間。如需變更，請先取消訂單再重新購買。`,
      list5: `即使在活動期間內多次下單，每人僅有1次中獎機會。`,
      list6: `攜帶商品登機與回國入境時，請遵守各國海關法規及航空公司的隨身行李規定，請旅客自行事先確認並辦理手續。本公司對攜帶商品登機與回國入境相關事宜概不負責，敬請見諒。`,
      list7: `如因完美行方面的失誤導致無法順利取貨時，贈送的威士忌將改為提供下次可使用的補償5千日圓折價券(購買金額1萬日圓以上適用)(不適用醫藥品與酒類商品)。\n而原購入商品將以退款或是跨國郵寄方式處理，後續將由相關人員與您聯繫與確認細節。`,
      list8: `本活動可能會在未提前通知的情況下變更或提前結束。`,
      list9: `凡參與本活動，即視同承認及接受本活動注意事項及相關規定。若有未盡事宜，悉依本公司之相關公告辦理；本公司保留最終解釋及決定權利。`
    },
    prize: {
      list1: `將於取貨日3天前通知得獎者。`,
      list2: `獎品將與其他訂購商品一同包裝出貨。`,
      list3: `即使未能與得獎者取得聯繫，獎品仍會與訂購商品一同放入免稅袋。`
    }
  },
  yearEndSale: {
    metaDescription: `【最多享8折】迎接年末年初的多款超值好物！`,
    metaTitle: `歲末＆新春大感謝祭！`,
    popularProductsTitle: `推薦的熱門商品`,
    startShopping: `立即瀏覽人氣商品！`
  }
} as const;
